function _typeof2(obj) { "@babel/helpers - typeof"; return _typeof2 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof2(obj); }
/*
	active-resource 1.0.0-beta.7
	(c) 2019 Nick Landgrebe && Peak Labs, LLC DBA Occasion App
	active-resource may be freely distributed under the MIT license
	Portions of active-resource were inspired by or borrowed from Rail's ActiveRecord library
*/

!function (global, factory) {
  "object" == (typeof exports === "undefined" ? "undefined" : _typeof2(exports)) && "undefined" != typeof module ? module.exports = factory(require("axios"), require("es6-promise"), require("qs"), require("underscore"), require("underscore.string"), require("underscore.inflection")) : "function" == typeof define && define.amd ? define(["axios", "es6-promise", "qs", "underscore", "underscore.string", "underscore.inflection"], factory) : global.ActiveResource = factory(global.axios, global.es6Promise, global.Qs, global._, global.s);
}(this, function (axios, es6Promise, Qs, _, s) {
  "use strict";

  function _typeof(obj) {
    return (_typeof = "function" == typeof Symbol && "symbol" == _typeof2(Symbol.iterator) ? function (obj) {
      return _typeof2(obj);
    } : function (obj) {
      return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : _typeof2(obj);
    })(obj);
  }
  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
  }
  function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || !1, descriptor.configurable = !0, "value" in descriptor && (descriptor.writable = !0), Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  function _createClass(Constructor, protoProps, staticProps) {
    return protoProps && _defineProperties(Constructor.prototype, protoProps), staticProps && _defineProperties(Constructor, staticProps), Constructor;
  }
  function _inherits(subClass, superClass) {
    if ("function" != typeof superClass && null !== superClass) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        writable: !0,
        configurable: !0
      }
    }), superClass && _setPrototypeOf(subClass, superClass);
  }
  function _getPrototypeOf(o) {
    return (_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function (o) {
      return o.__proto__ || Object.getPrototypeOf(o);
    })(o);
  }
  function _setPrototypeOf(o, p) {
    return (_setPrototypeOf = Object.setPrototypeOf || function (o, p) {
      return o.__proto__ = p, o;
    })(o, p);
  }
  function _possibleConstructorReturn(self, call) {
    return !call || "object" != _typeof2(call) && "function" != typeof call ? function (self) {
      if (void 0 === self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return self;
    }(self) : call;
  }
  function _get(target, property, receiver) {
    return (_get = "undefined" != typeof Reflect && Reflect.get ? Reflect.get : function (target, property, receiver) {
      var base = function (object, property) {
        for (; !Object.prototype.hasOwnProperty.call(object, property) && null !== (object = _getPrototypeOf(object)););
        return object;
      }(target, property);
      if (base) {
        var desc = Object.getOwnPropertyDescriptor(base, property);
        return desc.get ? desc.get.call(receiver) : desc.value;
      }
    })(target, property, receiver || target);
  }
  function _toConsumableArray(arr) {
    return function (arr) {
      if (Array.isArray(arr)) {
        for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];
        return arr2;
      }
    }(arr) || function (iter) {
      if (Symbol.iterator in Object(iter) || "[object Arguments]" === Object.prototype.toString.call(iter)) return Array.from(iter);
    }(arr) || function () {
      throw new TypeError("Invalid attempt to spread non-iterable instance");
    }();
  }
  var ActiveResource;
  axios = axios && axios.hasOwnProperty("default") ? axios["default"] : axios, es6Promise = es6Promise && es6Promise.hasOwnProperty("default") ? es6Promise["default"] : es6Promise, Qs = Qs && Qs.hasOwnProperty("default") ? Qs["default"] : Qs, _ = _ && _.hasOwnProperty("default") ? _["default"] : _, s = s && s.hasOwnProperty("default") ? s["default"] : s, "object" === ("undefined" == typeof exports ? "undefined" : _typeof(exports)) && "undefined" != typeof module || (window.Promise = es6Promise.Promise);
  var activeResource = ActiveResource = function ActiveResource() {
    _classCallCheck(this, ActiveResource);
  };
  return function () {
    ActiveResource.extend = function (klass, mixin) {
      var overwrite = arguments.length > 2 && void 0 !== arguments[2] && arguments[2];
      return Object.getOwnPropertyNames(mixin).filter(function (name) {
        return ["arguments", "caller", "length", "name", "prototype"].indexOf(name) < 0;
      }).forEach(function (name) {
        var method;
        if (method = mixin[name], !(!overwrite && klass[name] || method.__excludeFromExtend)) return klass[name] = method;
      });
    }, ActiveResource.include = function (klass, mixin) {
      var overwrite = arguments.length > 2 && void 0 !== arguments[2] && arguments[2];
      return this.extend(klass.prototype, mixin, overwrite);
    };
  }.call(void 0), function () {
    ActiveResource.prototype.Typing = function () {
      var getPrototypeOf$$1,
        Typing = function () {
          function Typing() {
            _classCallCheck(this, Typing);
          }
          return _createClass(Typing, null, [{
            key: "klass",
            value: function value() {
              return this.constructor;
            }
          }, {
            key: "isA",
            value: function value(klass) {
              var match, object;
              for (match = (object = this.constructor) === klass; !match && null != (object = getPrototypeOf$$1(object));) match = object === klass;
              return match;
            }
          }]), Typing;
        }();
      return getPrototypeOf$$1 = function getPrototypeOf$$1(o) {
        return (Object.setPrototypeOf ? Object.getPrototypeOf : function (o) {
          return o.__proto__ || Object.getPrototypeOf(o);
        })(o);
      }, Typing;
    }.call(this);
  }.call(void 0), function () {
    ActiveResource.createResourceLibrary = function (baseUrl) {
      var _interface,
        options = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
      return _interface = options["interface"] || ActiveResource.Interfaces.JsonApi, new (function () {
        function ResourceLibrary() {
          var base,
            resourceLibrary,
            _this2 = this;
          _classCallCheck(this, ResourceLibrary), Object.defineProperties(this, {
            headers: {
              get: function get() {
                return _this2._headers;
              },
              set: function set(value) {
                return _this2._headers = value, _this2["interface"] = new _interface(_this2);
              }
            }
          }), this.baseUrl = "/" === baseUrl.charAt(baseUrl.length - 1) ? baseUrl : "".concat(baseUrl, "/"), this._headers = options.headers, this["interface"] = new _interface(this), this.constantizeScope = options.constantizeScope, this.immutable = options.immutable, this.includePolymorphicRepeats = options.includePolymorphicRepeats, this.strictAttributes = options.strictAttributes, base = this.immutable ? ActiveResource.prototype.Immutable.prototype.Base : ActiveResource.prototype.Base, resourceLibrary = this, this.Base = function () {
            var Base = function (_base) {
              function Base() {
                return _classCallCheck(this, Base), _possibleConstructorReturn(this, _getPrototypeOf(Base).apply(this, arguments));
              }
              return _inherits(Base, base), Base;
            }();
            return Base.resourceLibrary = resourceLibrary, Base;
          }.call(this);
        }
        return _createClass(ResourceLibrary, [{
          key: "constantize",
          value: function value(className) {
            var i, klass, len, scope, v;
            if (klass = null, !_.isUndefined(className) && !_.isNull(className)) for (i = 0, len = (scope = this.constantizeScope && _.values(this.constantizeScope) || _.values(this)).length; i < len; i++) v = scope[i], _.isObject(v) && v.className === className && (klass = v);
            if (null == klass) throw "NameError: klass ".concat(className, " does not exist");
            return klass;
          }
        }, {
          key: "createResource",
          value: function value(klass) {
            return klass.className || (klass.className = klass.name), klass.queryName || (klass.queryName = _.pluralize(s.underscored(klass.className))), "function" == typeof klass.define && klass.define(), (this.constantizeScope || this)[klass.className] = klass, klass;
          }
        }]), ResourceLibrary;
      }())();
    };
  }.call(void 0), function () {
    ActiveResource.Interfaces = ActiveResource.prototype.Interfaces = function () {
      var Interfaces = function Interfaces() {
        _classCallCheck(this, Interfaces);
      };
      return Interfaces.prototype.Base = function () {
        var Base = function () {
          function Base(resourceLibrary) {
            _classCallCheck(this, Base), this.resourceLibrary = resourceLibrary, this.axios = axios.create({
              headers: _.extend(_.clone(this.resourceLibrary.headers || {}), {
                "Content-Type": this.constructor.contentType
              })
            }), this.axios.interceptors.response.use(function (config) {
              return config;
            }, function (error) {
              return 408 === error.response.status || "ECONNABORTED" === error.code ? Promise.reject({
                response: {
                  data: {
                    errors: [{
                      code: "timeout",
                      detail: "Timeout occurred while loading ".concat(error.config.url)
                    }]
                  }
                }
              }) : Promise.reject(error);
            });
          }
          return _createClass(Base, [{
            key: "request",
            value: function value(url, method, data) {
              var options;
              return options = {
                responseType: "json",
                method: method,
                url: url
              }, "GET" === method ? (options.params = data, options.paramsSerializer = function (params) {
                return Qs.stringify(params, {
                  arrayFormat: "brackets"
                });
              }) : options.data = data, this.axios.request(options);
            }
          }, {
            key: "get",
            value: function value(url, queryParams) {
              throw "#get not implemented on base interface";
            }
          }, {
            key: "post",
            value: function value(url, resourceData, options) {
              throw "#post not implemented on base interface";
            }
          }, {
            key: "patch",
            value: function value(url, resourceData, options) {
              throw "#patch not implemented on base interface";
            }
          }, {
            key: "put",
            value: function value(url, resourceData, options) {
              throw "#put not implemented on base interface";
            }
          }, {
            key: "delete",
            value: function value(url, resourceData, options) {
              throw "#delete not implemented on base interface";
            }
          }]), Base;
        }();
        return Base.contentType = "application/json", Base;
      }.call(this), Interfaces;
    }.call(this);
  }.call(void 0), function () {
    ActiveResource.Interfaces.JsonApi = ActiveResource.prototype.Interfaces.prototype.JsonApi = function () {
      var JsonApi = function (_ActiveResource$proto) {
        function JsonApi() {
          return _classCallCheck(this, JsonApi), _possibleConstructorReturn(this, _getPrototypeOf(JsonApi).apply(this, arguments));
        }
        return _inherits(JsonApi, ActiveResource.prototype.Interfaces.prototype.Base), _createClass(JsonApi, [{
          key: "request",
          value: function value(url, method, data) {
            return _get(_getPrototypeOf(JsonApi.prototype), "request", this).call(this, url, method, data).then(function (response) {
              var ref;
              if (null == (null != (ref = response.data) ? ref.data : void 0) && 204 !== response.status) throw "Response from ".concat(url, " was not in JSON API format");
              return response.data;
            });
          }
        }, {
          key: "toUnderscored",
          value: function value(object) {
            var k,
              underscored,
              underscorize,
              v,
              _this3 = this;
            for (k in underscored = {}, underscorize = function underscorize(value) {
              return !_.isObject(value) || ("function" == typeof value.isA ? value.isA(ActiveResource.prototype.Base) : void 0) || ("function" == typeof value.isA ? value.isA(ActiveResource.prototype.Collection) : void 0) || _.isDate(value) ? value : _this3.toUnderscored(value);
            }, object) v = object[k], underscored[s.underscored(k)] = _.isArray(v) ? _.map(v, underscorize) : underscorize(v);
            return underscored;
          }
        }, {
          key: "toCamelCase",
          value: function value(object) {
            var camelize,
              camelized,
              k,
              v,
              _this4 = this;
            for (k in camelized = {}, camelize = function camelize(value) {
              return !_.isObject(value) || ("function" == typeof value.isA ? value.isA(ActiveResource.prototype.Base) : void 0) || ("function" == typeof value.isA ? value.isA(ActiveResource.prototype.Collection) : void 0) ? value : _this4.toCamelCase(value);
            }, object) v = object[k], camelized[s.camelize(k)] = _.isArray(v) ? _.map(v, camelize) : camelize(v);
            return camelized;
          }
        }, {
          key: "buildFilters",
          value: function value(filters) {
            return this.toUnderscored(_.mapObject(filters, function (value) {
              var transformValue;
              return transformValue = function transformValue(v) {
                return (null != v && "function" == typeof v.isA ? v.isA(ActiveResource.prototype.Base) : void 0) ? v[v.klass().primaryKey] : _.isNull(v) ? "%00" : v;
              }, _.isArray(value) || (null != value && "function" == typeof value.isA ? value.isA(ActiveResource.Collection) : void 0) ? ActiveResource.Collection.build(value).map(function (v) {
                return transformValue(v);
              }).join() : transformValue(value);
            }));
          }
        }, {
          key: "buildSparseFieldset",
          value: function value(fields, queryParams) {
            var _mergeNestedIncludes2;
            return fields = _.clone(fields), queryParams.include && (_mergeNestedIncludes2 = function _mergeNestedIncludes(includes) {
              var keyForString = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : queryParams.__root;
              return ActiveResource.Collection.build(includes).each(function (include) {
                var k, key, value;
                return _.isString(include) ? (fields[keyForString] || (fields[keyForString] = []), fields[keyForString] = fields[keyForString].slice(0), fields[keyForString].push(include)) : _.isObject(include) ? _.keys(include).length > 1 ? _mergeNestedIncludes2(function () {
                  var j, len, ref, results;
                  for (results = [], j = 0, len = (ref = _.keys(include)).length; j < len; j++) k = ref[j], results.push(_.pick(include, k));
                  return results;
                }()) : (key = _.keys(include)[0], value = _.values(include)[0], _.isArray(value) ? void _mergeNestedIncludes2(value, key) : (_.isObject(value) && (_mergeNestedIncludes2(function () {
                  var j, len, ref, results;
                  for (results = [], j = 0, len = (ref = _.keys(value)).length; j < len; j++) k = ref[j], results.push(_.pick(value, k));
                  return results;
                }()), value = _.keys(value)[0]), fields[key] || (fields[key] = []), fields[key] = fields[key].slice(0), fields[key].push(value))) : void 0;
              });
            })(queryParams.include), this.toUnderscored(_.mapObject(fields, function (fieldArray) {
              return _.map(fieldArray, function (f) {
                return s.underscored(f);
              }).join();
            }));
          }
        }, {
          key: "buildIncludeTree",
          value: function value(includes) {
            var _buildNestedIncludes2;
            return _buildNestedIncludes2 = function _buildNestedIncludes(object) {
              var modelName, value;
              return modelName = s.underscored(_.keys(object)[0]), value = _.values(object)[0], ActiveResource.prototype.Collection.build([value]).flatten().map(function (item) {
                return _.isString(item) ? _.map(item.split(","), function (i) {
                  return s.underscored(i);
                }) : _.isObject(item) ? _buildNestedIncludes2(item) : void 0;
              }).flatten().map(function (i) {
                return "".concat(modelName, ".").concat(i);
              }).toArray();
            }, ActiveResource.prototype.Collection.build(includes).inject([], function (includeStrArray, include) {
              return _.isObject(include) ? (includeStrArray.push.apply(includeStrArray, _toConsumableArray(_buildNestedIncludes2(include))), includeStrArray) : (includeStrArray.push(s.underscored(include)), includeStrArray);
            }).join();
          }
        }, {
          key: "buildSortList",
          value: function value(sortObject) {
            var column, dir, output;
            for (column in output = [], sortObject) "asc" === (dir = sortObject[column]) ? output.push(s.underscored(column)) : "desc" === dir && output.push("-".concat(s.underscored(column)));
            return output.join(",");
          }
        }, {
          key: "buildResourceIdentifier",
          value: function value(resource) {
            var identifier, primaryKeyValue;
            return identifier = {
              type: resource.klass().queryName
            }, (primaryKeyValue = resource[resource.klass().primaryKey]) && (identifier[resource.klass().primaryKey] = primaryKeyValue.toString()), identifier;
          }
        }, {
          key: "buildResourceRelationships",
          value: function value(resource, relationships) {
            var output,
              _this5 = this,
              onlyChanged = arguments.length > 2 && void 0 !== arguments[2] && arguments[2];
            return output = {}, _.each(relationships, function (relationship) {
              var reflection, target;
              if (reflection = resource.klass().reflectOnAssociation(relationship), target = resource.association(reflection.name).target, onlyChanged || !(reflection.collection() && target.empty() || null == target)) return output[s.underscored(reflection.name)] = {
                data: _this5.buildResourceDocument({
                  resourceData: target,
                  onlyResourceIdentifiers: !reflection.autosave(),
                  onlyChanged: onlyChanged,
                  parentReflection: reflection.polymorphic() ? reflection.polymorphicInverseOf(target.klass()) : reflection.inverseOf()
                })
              };
            }), output;
          }
        }, {
          key: "buildResourceDocument",
          value: function value(_ref) {
            var data,
              _this6 = this,
              resourceData = _ref.resourceData,
              onlyResourceIdentifiers = _ref.onlyResourceIdentifiers,
              onlyChanged = _ref.onlyChanged,
              parentReflection = _ref.parentReflection;
            return onlyResourceIdentifiers = onlyResourceIdentifiers || !1, onlyChanged = onlyChanged || !1, data = ActiveResource.prototype.Collection.build(resourceData).compact().map(function (resource) {
              var attributes, changedFields, documentResource, relationships;
              return documentResource = _this6.buildResourceIdentifier(resource), onlyResourceIdentifiers || (attributes = _.omit(resource.attributes({
                readWrite: !0
              }), resource.klass().primaryKey), relationships = _.keys(resource.klass().reflections()), parentReflection && (parentReflection.polymorphic() && _this6.resourceLibrary.includePolymorphicRepeats || (relationships = _.without(relationships, parentReflection.name))), onlyChanged && (changedFields = resource.changedFields().toArray(), attributes = _.pick.apply(_, [attributes].concat(_toConsumableArray(changedFields))), relationships = _.intersection(relationships, changedFields)), documentResource.attributes = _this6.toUnderscored(attributes), documentResource.relationships = _this6.buildResourceRelationships(resource, relationships, onlyChanged)), documentResource;
            }), _.isArray(resourceData) || _.isObject(resourceData) && ("function" == typeof resourceData.isA ? resourceData.isA(ActiveResource.prototype.Collection) : void 0) ? data.toArray() : data.first() || null;
          }
        }, {
          key: "buildResource",
          value: function value(data, includes, _ref2) {
            var attributes,
              justCreated,
              resource,
              _this7 = this,
              existingResource = _ref2.existingResource,
              parentRelationship = _ref2.parentRelationship;
            return resource = existingResource || this.resourceLibrary.constantize(_.singularize(s.classify(data.type))).build(), justCreated = existingResource && existingResource.newResource(), attributes = data.attributes || {}, data[resource.klass().primaryKey] && (attributes[resource.klass().primaryKey] = data[resource.klass().primaryKey].toString()), null != parentRelationship && (attributes = _.extend(attributes, parentRelationship)), attributes = this.addRelationshipsToFields(attributes, data.relationships, includes, resource), attributes = this.toCamelCase(attributes), resource.__assignFields(attributes), resource.__links = _.extend(resource.links(), data.links), resource.klass().reflectOnAllAssociations().each(function (reflection) {
              var association, ref, ref1, ref2, ref3, relationship, relationshipEmpty, relationshipLinks, selfLink, url_safe_reflection_name;
              if (association = resource.association(reflection.name), null != (relationshipLinks = null != (ref = data.relationships) && null != (ref1 = ref[s.underscored(reflection.name)]) ? ref1.links : void 0) ? association.__links = _.extend(association.links(), _.mapObject(relationshipLinks, function (l) {
                return ActiveResource.prototype.Links.__constructLink(l);
              })) : null != (selfLink = resource.links().self) && (url_safe_reflection_name = s.underscored(reflection.name), association.__links = {
                self: ActiveResource.prototype.Links.__constructLink(selfLink, "relationships", url_safe_reflection_name),
                related: ActiveResource.prototype.Links.__constructLink(selfLink, url_safe_reflection_name)
              }), relationshipEmpty = _.isObject(relationship = null != (ref2 = data.relationships) && null != (ref3 = ref2[s.underscored(reflection.name)]) ? ref3.data : void 0) ? 0 === _.keys(relationship).length : _this7.resourceLibrary.immutable ? !_.isUndefined(relationship) && (_.isNull(relationship) || _.isEmpty(relationship) || _.has(attributes, reflection.name)) : null == relationship || 0 === relationship.length, _.has(attributes, reflection.name) || relationshipEmpty) return association.loaded(!0);
            }), justCreated && resource.__executeCallbacks("afterCreate"), resource.__executeCallbacks("afterRequest"), resource;
          }
        }, {
          key: "addRelationshipsToFields",
          value: function value(attributes, relationships, includes, resource) {
            var _this8 = this;
            return _.each(relationships, function (relationship, relationshipName) {
              var include, reflection, relationshipItems;
              if (reflection = resource.klass().reflectOnAssociation(s.camelize(relationshipName))) if (reflection.collection()) {
                if (!("function" == typeof (relationshipItems = ActiveResource.prototype.Collection.build(relationship.data).map(function (relationshipMember, index) {
                  return _this8.findResourceForRelationship(relationshipMember, includes, resource, reflection, index);
                }).compact()).empty ? relationshipItems.empty() : void 0)) return attributes[relationshipName] = relationshipItems;
              } else if (null != relationship.data && null != (include = _this8.findResourceForRelationship(relationship.data, includes, resource, reflection))) return attributes[relationshipName] = include;
            }), attributes;
          }
        }, {
          key: "findResourceForRelationship",
          value: function value(relationshipData, includes, resource, reflection, index) {
            var buildResourceOptions, findConditions, include, parentReflection, potentialTarget, primaryKey, target;
            if (primaryKey = resource.klass().primaryKey, (findConditions = {
              type: relationshipData.type
            })[primaryKey] = relationshipData[primaryKey], include = _.findWhere(includes, findConditions), reflection.collection() ? target = resource.association(reflection.name).target.detect(function (t) {
              return t[primaryKey] === findConditions[primaryKey];
            }) || resource.association(reflection.name).target.get(index) : null != (potentialTarget = resource.association(reflection.name).target) && (reflection.polymorphic() && potentialTarget.klass().queryName !== findConditions.type || (target = potentialTarget)), buildResourceOptions = {}, null != (parentReflection = reflection.polymorphic() ? reflection.polymorphicInverseOf(this.resourceLibrary.constantize(_.singularize(s.classify(relationshipData.type)))) : reflection.inverseOf()) && (buildResourceOptions.parentRelationship = {}, buildResourceOptions.parentRelationship[parentReflection.name] = parentReflection.collection() ? [resource] : resource), null != target && (buildResourceOptions.existingResource = target), null != target || null != include) return this.buildResource(include || {}, includes, buildResourceOptions);
          }
        }, {
          key: "mergePersistedChanges",
          value: function value(response, resource) {
            return this.buildResource(response.data, response.included, {
              existingResource: resource
            });
          }
        }, {
          key: "resourceErrors",
          value: function value(resource, errors) {
            var errorCollection;
            return errorCollection = ActiveResource.Collection.build(errors).map(function (error) {
              var field;
              return field = [], "/data" === error.source.pointer ? field.push("base") : _.each(error.source.pointer.split("/data"), function (i) {
                var m;
                if (null != (m = i.match(/\/(attributes|relationships|)\/(\w+)/))) return field.push(s.camelize(m[2]));
              }), resource.errors().__buildError(field.join("."), s.camelize(error.code), error.detail);
            }), resource.errors().propagate(errorCollection), resource;
          }
        }, {
          key: "parameterErrors",
          value: function value(errors) {
            return ActiveResource.prototype.Collection.build(errors).map(function (error) {
              var out, ref;
              return out = {
                detail: error.detail,
                message: error.detail
              }, null != (null != (ref = error.source) ? ref.parameter : void 0) && (out.parameter = s.camelize(error.source.parameter)), out.code = s.camelize(error.code), out;
            });
          }
        }, {
          key: "get",
          value: function value(url) {
            var _this,
              data,
              queryParams = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
            return data = {}, null != queryParams.filter && (data.filter = this.buildFilters(queryParams.filter)), null != queryParams.fields && (data.fields = this.buildSparseFieldset(queryParams.fields, queryParams)), null != queryParams.include && (data.include = this.buildIncludeTree(queryParams.include)), null != queryParams.sort && (data.sort = this.buildSortList(queryParams.sort)), null != queryParams.page && (data.page = queryParams.page), null != queryParams.limit && (data.limit = queryParams.limit), null != queryParams.offset && (data.offset = queryParams.offset), _this = this, this.request(url, "GET", data).then(function (response) {
              var built;
              return (built = ActiveResource.prototype.CollectionResponse.build(_.flatten([response.data])).map(function (object) {
                return (object = _this.buildResource(object, response.included, {})).assignResourceRelatedQueryParams(queryParams), object;
              })).links(response.links), _.isArray(response.data) ? built : built.first();
            }, function (errors) {
              return Promise.reject(_this.parameterErrors(errors.response.data.errors));
            });
          }
        }, {
          key: "post",
          value: function value(url, resourceData) {
            var _this,
              data,
              queryParams,
              options = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
            return data = {
              data: this.buildResourceDocument({
                resourceData: resourceData,
                onlyResourceIdentifiers: options.onlyResourceIdentifiers
              })
            }, options.onlyResourceIdentifiers || (null != (queryParams = resourceData.queryParams()).fields && (data.fields = this.buildSparseFieldset(queryParams.fields, queryParams)), null != queryParams.include && (data.include = this.buildIncludeTree(queryParams.include))), _this = this, this.request(url, "POST", data).then(function (response) {
              return options.onlyResourceIdentifiers ? response : _this.mergePersistedChanges(response, resourceData);
            }, function (errors) {
              return options.onlyResourceIdentifiers ? Promise.reject(errors) : Promise.reject(_this.resourceErrors(resourceData, errors.response.data.errors));
            });
          }
        }, {
          key: "patch",
          value: function value(url, resourceData) {
            var _this,
              data,
              queryParams,
              options = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
            return data = {
              data: this.buildResourceDocument({
                resourceData: resourceData,
                onlyResourceIdentifiers: options.onlyResourceIdentifiers,
                onlyChanged: !0
              })
            }, options.onlyResourceIdentifiers || (null != (queryParams = resourceData.queryParams()).fields && (data.fields = this.buildSparseFieldset(queryParams.fields, queryParams)), null != queryParams.include && (data.include = this.buildIncludeTree(queryParams.include))), _this = this, this.request(url, "PATCH", data).then(function (response) {
              return options.onlyResourceIdentifiers ? response : _this.mergePersistedChanges(response, resourceData);
            }, function (errors) {
              return options.onlyResourceIdentifiers ? Promise.reject(errors) : Promise.reject(_this.resourceErrors(resourceData, errors.response.data.errors));
            });
          }
        }, {
          key: "put",
          value: function value(url, resourceData) {
            var _this,
              data,
              queryParams,
              options = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
            return data = {
              data: this.buildResourceDocument({
                resourceData: resourceData,
                onlyResourceIdentifiers: options.onlyResourceIdentifiers
              })
            }, options.onlyResourceIdentifiers || (null != (queryParams = resourceData.queryParams()).fields && (data.fields = this.buildSparseFieldset(queryParams.fields, queryParams)), null != queryParams.include && (data.include = this.buildIncludeTree(queryParams.include))), _this = this, this.request(url, "PUT", data).then(function (response) {
              return options.onlyResourceIdentifiers ? response : _this.mergePersistedChanges(response, resourceData);
            }, function (errors) {
              return options.onlyResourceIdentifiers ? Promise.reject(errors) : Promise.reject(_this.resourceErrors(resourceData, errors.response.data.errors));
            });
          }
        }, {
          key: "delete",
          value: function value(url, resourceData) {
            var _this, data;
            return data = null != resourceData ? {
              data: this.buildResourceDocument({
                resourceData: resourceData,
                onlyResourceIdentifiers: !0
              })
            } : {}, _this = this, this.request(url, "DELETE", data).then(null, function (errors) {
              return errors.response.data ? Promise.reject(_this.parameterErrors(errors.response.data.errors)) : Promise.reject(null);
            });
          }
        }]), JsonApi;
      }();
      return JsonApi.contentType = "application/vnd.api+json", JsonApi;
    }.call(this);
  }.call(void 0), function () {
    ActiveResource.prototype.Associations = function () {
      function Associations() {
        _classCallCheck(this, Associations);
      }
      return _createClass(Associations, [{
        key: "association",
        value: function value(name) {
          var association, reflection;
          if (this.__associations || (this.__associations = {}), null == (association = this.__associations[name])) {
            if (null == (reflection = this.klass().reflectOnAssociation(name))) throw "Association ".concat(name, " does not exist");
            association = new (reflection.associationClass())(this, reflection), this.__associations[name] = association;
          }
          return association;
        }
      }], [{
        key: "hasMany",
        value: function value(name) {
          var reflection,
            options = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
          return reflection = ActiveResource.prototype.Associations.prototype.Builder.prototype.HasMany.build(this, name, options), ActiveResource.prototype.Reflection.addReflection(this, name, reflection);
        }
      }, {
        key: "hasOne",
        value: function value(name) {
          var reflection,
            options = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
          return reflection = ActiveResource.prototype.Associations.prototype.Builder.prototype.HasOne.build(this, name, options), ActiveResource.prototype.Reflection.addReflection(this, name, reflection);
        }
      }, {
        key: "belongsTo",
        value: function value(name) {
          var reflection,
            options = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
          return reflection = ActiveResource.prototype.Associations.prototype.Builder.prototype.BelongsTo.build(this, name, options), ActiveResource.prototype.Reflection.addReflection(this, name, reflection);
        }
      }]), Associations;
    }();
  }.call(void 0), function () {
    ActiveResource.prototype.Attributes = function () {
      function Attributes() {
        _classCallCheck(this, Attributes);
      }
      return _createClass(Attributes, [{
        key: "attributes",
        value: function value() {
          var _this$__attributes$al, options, _this$__attributes$re, _this$__attributes$re2;
          options = {};
          for (var _len = arguments.length, _attributes = new Array(_len), _key = 0; _key < _len; _key++) _attributes[_key] = arguments[_key];
          (_.isObject(_.last(_attributes)) && (options = _attributes.pop()), null == this.__attributes && (this.__attributes = {
            all: ActiveResource.prototype.Collection.build(),
            read: ActiveResource.prototype.Collection.build(),
            readWrite: ActiveResource.prototype.Collection.build()
          }), options.readOnly) ? (_this$__attributes$re = this.__attributes.read).push.apply(_this$__attributes$re, _attributes) : (_this$__attributes$re2 = this.__attributes.readWrite).push.apply(_this$__attributes$re2, _attributes);
          return (_this$__attributes$al = this.__attributes.all).push.apply(_this$__attributes$al, _attributes), this.__attributes;
        }
      }], [{
        key: "hasAttribute",
        value: function value(attribute) {
          return null != this.__readAttribute(attribute);
        }
      }, {
        key: "assignAttributes",
        value: function value(attributes) {
          return this.__assignAttributes(attributes);
        }
      }, {
        key: "attributes",
        value: function value() {
          var k,
            output,
            v,
            options = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
          for (k in output = {}, this, this) v = this[k], this.__validAttribute(k, v, options) && (output[k] = v);
          return output;
        }
      }, {
        key: "reload",
        value: function value() {
          var ref, resource, url;
          if (!(this.persisted() || (null != (ref = this.id) ? ref.toString().length : void 0) > 0)) throw "Cannot reload a resource that is not persisted or has an ID";
          return resource = this, url = this.links().self || ActiveResource.prototype.Links.__constructLink(this.links().related, this.id.toString()), this["interface"]().get(url, this.queryParams()).then(function (reloaded) {
            return resource.__assignFields(reloaded.attributes()), resource.klass().reflectOnAllAssociations().each(function (reflection) {
              var target;
              return target = reloaded.association(reflection.name).reader(), ("function" == typeof reflection.collection ? reflection.collection() : void 0) && (target = target.toArray()), resource.association(reflection.name).writer(target, !1);
            }), resource;
          });
        }
      }, {
        key: "__assignAttributes",
        value: function value(attributes) {
          var k, v;
          for (k in attributes) {
            v = attributes[k];
            try {
              this.association(k).writer(v, !1);
            } catch (error) {
              this[k] = v;
            }
          }
          return null;
        }
      }, {
        key: "__readAttribute",
        value: function value(attribute) {
          return this.attributes()[attribute];
        }
      }, {
        key: "__validAttribute",
        value: function value(attribute, _value, options) {
          var reserved;
          return reserved = ["__super__", "__associations", "__errors", "__fields", "__links", "__queryParams"], this.klass().resourceLibrary.strictAttributes ? options.readOnly ? this.klass().attributes().read.include(attribute) : options.readWrite ? this.klass().attributes().readWrite.include(attribute) : this.klass().attributes().all.include(attribute) : !_.isFunction(_value) && !_.contains(reserved, attribute) && function () {
            try {
              return null == this.association(attribute);
            } catch (error) {
              return !0;
            }
          }.call(this);
        }
      }]), Attributes;
    }();
  }.call(void 0), function () {
    ActiveResource.prototype.Callbacks = function () {
      function Callbacks() {
        _classCallCheck(this, Callbacks);
      }
      return _createClass(Callbacks, [{
        key: "callbacks",
        value: function value() {
          return this.__callbacks || (this.__callbacks = {
            afterBuild: ActiveResource.prototype.Collection.build(),
            afterCreate: ActiveResource.prototype.Collection.build(),
            afterRequest: ActiveResource.prototype.Collection.build()
          });
        }
      }, {
        key: "afterBuild",
        value: function value(func) {
          return this.callbacks().afterBuild.push(func);
        }
      }, {
        key: "afterCreate",
        value: function value(func) {
          return this.callbacks().afterCreate.push(func);
        }
      }, {
        key: "afterRequest",
        value: function value(func) {
          return this.callbacks().afterRequest.push(func);
        }
      }], [{
        key: "__executeCallbacks",
        value: function value(type) {
          var _this9 = this;
          return this.klass().callbacks()[type].each(function (callback) {
            return _.bind(callback, _this9)();
          });
        }
      }]), Callbacks;
    }();
  }.call(void 0), function () {
    ActiveResource.prototype.Cloning = function () {
      function Cloning() {
        _classCallCheck(this, Cloning);
      }
      return _createClass(Cloning, null, [{
        key: "clone",
        value: function value() {
          return this.__createClone({});
        }
      }, {
        key: "__createClone",
        value: function value(_ref3) {
          var attributes,
            clone,
            _this10 = this,
            cloner = _ref3.cloner,
            newCloner = _ref3.newCloner;
          return clone = this.klass().build(), this.errors().each(function (attribute, e) {
            return clone.errors().push(_.clone(e));
          }), clone.__links = _.clone(this.links()), clone.__queryParams = _.clone(this.queryParams()), (attributes = {})[this.klass().primaryKey] = this[this.klass().primaryKey], clone.__assignAttributes(_.extend(attributes, this.attributes())), this.klass().fields().each(function (f) {
            var newAssociation, oldAssociation, ref, ref1, ref2, ref3, reflection, target;
            clone.__fields[f] = null != (null != (ref = _this10.__fields[f]) ? ref.toArray : void 0) ? _this10.__fields[f].clone() : _this10.__fields[f];
            try {
              return oldAssociation = _this10.association(f), (newAssociation = clone.association(f)).__links = _.clone(oldAssociation.links()), oldAssociation.loaded() && newAssociation.loaded(!0), target = (reflection = oldAssociation.reflection).collection() ? reflection.autosave() && oldAssociation.target.include(cloner) ? _this10.__createCollectionAutosaveAssociationClone(oldAssociation, {
                parentClone: clone,
                cloner: cloner,
                newCloner: newCloner
              }) : (null != (ref1 = reflection.inverseOf()) ? ref1.autosave() : void 0) ? _this10.__createCollectionInverseAutosaveAssociationClone(oldAssociation, {
                parentClone: clone,
                cloner: cloner
              }) : oldAssociation.target : reflection.polymorphic() ? oldAssociation.target : reflection.autosave() && oldAssociation.target === cloner ? _this10.__createSingularAutosaveAssociationClone(oldAssociation, {
                parentClone: clone,
                newCloner: newCloner
              }) : (null != (ref2 = reflection.inverseOf()) ? ref2.autosave() : void 0) && null != oldAssociation.target ? _this10.__createSingularInverseAutosaveAssociationClone(oldAssociation, {
                parentClone: clone,
                cloner: cloner
              }) : ((null != (ref3 = reflection.inverseOf()) ? ref3.collection() : void 0) && _this10.__replaceSingularInverseCollectionAssociationClone(oldAssociation, {
                parentClone: clone
              }), oldAssociation.target), newAssociation.writer(target, !1);
            } catch (error) {
              return !0;
            }
          }), clone;
        }
      }, {
        key: "__createCollectionAutosaveAssociationClone",
        value: function value(association, _ref4) {
          var clone,
            inverse,
            _this11 = this,
            parentClone = _ref4.parentClone,
            cloner = _ref4.cloner,
            newCloner = _ref4.newCloner;
          return (clone = association.target.clone()).replace(cloner, newCloner), parentClone.__fields[association.reflection.name].replace(cloner, newCloner), null != (inverse = association.reflection.inverseOf()) && clone.each(function (t) {
            return t.__fields[inverse.name] === _this11 && (t.__fields[inverse.name] = parentClone), t.association(inverse.name).writer(parentClone, !1);
          }), clone;
        }
      }, {
        key: "__createCollectionInverseAutosaveAssociationClone",
        value: function value(association, _ref5) {
          var _this12 = this,
            parentClone = _ref5.parentClone,
            cloner = _ref5.cloner;
          return association.target.map(function (t) {
            var clone;
            return null != cloner && cloner === t ? cloner : (clone = t.__createClone({
              cloner: _this12,
              newCloner: parentClone
            }), parentClone.__fields[association.reflection.name].replace(t, clone), clone);
          });
        }
      }, {
        key: "__createSingularAutosaveAssociationClone",
        value: function value(association, _ref6) {
          var parentClone = _ref6.parentClone,
            newCloner = _ref6.newCloner;
          return parentClone.__fields[association.reflection.name] = newCloner, newCloner;
        }
      }, {
        key: "__createSingularInverseAutosaveAssociationClone",
        value: function value(association, _ref7) {
          var clone,
            parentClone = _ref7.parentClone,
            cloner = _ref7.cloner;
          return association.target === cloner ? cloner : (clone = association.target.__createClone({
            cloner: this,
            newCloner: parentClone
          }), parentClone.__fields[association.reflection.name] === association.target && (parentClone.__fields[association.reflection.name] = clone), clone);
        }
      }, {
        key: "__replaceSingularInverseCollectionAssociationClone",
        value: function value(association, _ref8) {
          var inverse,
            parentClone = _ref8.parentClone;
          return inverse = association.reflection.inverseOf(), association.target.association(inverse.name).target.replace(this, parentClone);
        }
      }]), Cloning;
    }();
  }.call(void 0), function () {
    ActiveResource.Collection = ActiveResource.prototype.Collection = function () {
      var Collection = function () {
        function Collection() {
          var __collection = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [];
          _classCallCheck(this, Collection), this.__collection = __collection;
        }
        return _createClass(Collection, null, [{
          key: "build",
          value: function value() {
            var array = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [];
            return (null != array && "function" == typeof array.isA ? array.isA(this) : void 0) ? array.clone() : null != (null != array ? array.length : void 0) ? new this(array) : new this([array]);
          }
        }]), _createClass(Collection, [{
          key: "size",
          value: function value() {
            return _.size(this.__collection);
          }
        }, {
          key: "empty",
          value: function value() {
            return 0 === this.size();
          }
        }, {
          key: "include",
          value: function value(item) {
            return this.indexOf(item) >= 0;
          }
        }, {
          key: "indexOf",
          value: function value(item) {
            return _.indexOf(this.__collection, item);
          }
        }, {
          key: "get",
          value: function value(index) {
            if (!(index >= this.size())) return this.__collection[index];
          }
        }, {
          key: "set",
          value: function value(index, item) {
            if (!(index >= this.size())) return this.__collection[index] = item;
          }
        }, {
          key: "replace",
          value: function value(original, next) {
            var index;
            return (index = this.indexOf(original)) > -1 && this.set(index, next), next;
          }
        }, {
          key: "toArray",
          value: function value() {
            return this.__collection;
          }
        }, {
          key: "all",
          value: function value() {
            return this.toArray();
          }
        }, {
          key: "first",
          value: function value(n) {
            var output;
            return output = _.first(this.__collection, n || 1), n ? output : output[0];
          }
        }, {
          key: "last",
          value: function value(n) {
            var output;
            return output = _.last(this.__collection, n || 1), n ? output : output[0];
          }
        }, {
          key: "each",
          value: function value(iteratee) {
            return _.each(this.__collection, iteratee);
          }
        }, {
          key: "inject",
          value: function value(memo, iteratee) {
            return _.reduce(this.__collection, iteratee, memo);
          }
        }, {
          key: "map",
          value: function value(iteratee) {
            return this.constructor.build(_.map(this.__collection, iteratee));
          }
        }, {
          key: "compact",
          value: function value(iteratee) {
            return this.constructor.build(_.without(this.__collection, null, void 0));
          }
        }, {
          key: "join",
          value: function value() {
            var separator = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : ",";
            return s.join.apply(s, [separator].concat(_toConsumableArray(_.map(this.__collection, function (i) {
              return i.toString();
            }))));
          }
        }, {
          key: "flatten",
          value: function value() {
            return this.constructor.build(_.flatten(this.__collection));
          }
        }, {
          key: "push",
          value: function value() {
            var _this$__collection;
            return (_this$__collection = this.__collection).push.apply(_this$__collection, arguments);
          }
        }, {
          key: "unshift",
          value: function value() {
            var _this$__collection2;
            return (_this$__collection2 = this.__collection).unshift.apply(_this$__collection2, arguments);
          }
        }, {
          key: "pop",
          value: function value() {
            return this.__collection.pop();
          }
        }, {
          key: "shift",
          value: function value() {
            return this.__collection.shift();
          }
        }, {
          key: "delete",
          value: function value() {
            for (var deleted, _len2 = arguments.length, items = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) items[_key2] = arguments[_key2];
            return deleted = _.intersection(this.__collection, items), this.__collection = _.without.apply(_, [this.__collection].concat(items)), deleted;
          }
        }, {
          key: "clear",
          value: function value() {
            return this.__collection = [];
          }
        }, {
          key: "select",
          value: function value(predicate) {
            return this.constructor.build(_.filter(this.__collection, predicate));
          }
        }, {
          key: "detect",
          value: function value(predicate) {
            return _.detect(this.__collection, predicate);
          }
        }, {
          key: "clone",
          value: function value() {
            return this.constructor.build(_.map(this.__collection, function (i) {
              return i;
            }));
          }
        }]), Collection;
      }();
      return ActiveResource.include(Collection, ActiveResource.prototype.Typing), Collection;
    }.call(this);
  }.call(void 0), function () {
    ActiveResource.CollectionResponse = ActiveResource.prototype.CollectionResponse = function (_ActiveResource$proto2) {
      function CollectionResponse() {
        return _classCallCheck(this, CollectionResponse), _possibleConstructorReturn(this, _getPrototypeOf(CollectionResponse).apply(this, arguments));
      }
      return _inherits(CollectionResponse, ActiveResource.prototype.Collection), _createClass(CollectionResponse, [{
        key: "links",
        value: function value() {
          var data = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
          return _.isEmpty(data) && null != this.__links || (this.__links = data), this.__links;
        }
      }, {
        key: "hasPrevPage",
        value: function value() {
          return null != this.links().prev;
        }
      }, {
        key: "hasNextPage",
        value: function value() {
          return null != this.links().next;
        }
      }, {
        key: "prevPage",
        value: function value() {
          if (this.hasPrevPage()) return this.prevPagePromise || (this.prevPagePromise = this.first().klass().resourceLibrary["interface"].get(this.links().prev));
        }
      }, {
        key: "nextPage",
        value: function value() {
          if (this.hasNextPage()) return this.nextPagePromise || (this.nextPagePromise = this.first().klass().resourceLibrary["interface"].get(this.links().next));
        }
      }, {
        key: "toCollection",
        value: function value() {
          return ActiveResource.prototype.Collection.build(this.toArray());
        }
      }], [{
        key: "build",
        value: function value() {
          var array = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [];
          return ("function" == typeof array.isA ? array.isA(ActiveResource.prototype.Collection) : void 0) ? new this(array.toArray()) : _get(_getPrototypeOf(CollectionResponse), "build", this).call(this, array);
        }
      }]), CollectionResponse;
    }();
  }.call(void 0), function () {
    ActiveResource.Errors = ActiveResource.prototype.Errors = function () {
      function Errors(base) {
        _classCallCheck(this, Errors), this.base = base, this.reset();
      }
      return _createClass(Errors, null, [{
        key: "errors",
        value: function value() {
          return this.__errors || (this.__errors = new ActiveResource.prototype.Errors(this));
        }
      }, {
        key: "valid",
        value: function value() {
          return this.errors().empty();
        }
      }]), _createClass(Errors, [{
        key: "reset",
        value: function value() {
          return this.__errors = {};
        }
      }, {
        key: "clear",
        value: function value() {
          return this.reset();
        }
      }, {
        key: "add",
        value: function value(field, code) {
          var detail = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : "";
          return this.__add(field, code, detail);
        }
      }, {
        key: "addAll",
        value: function value() {
          for (var _this13 = this, _len3 = arguments.length, errors = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) errors[_key3] = arguments[_key3];
          return _.map(errors, function (error) {
            return _this13.__add.apply(_this13, _toConsumableArray(error));
          });
        }
      }, {
        key: "propagate",
        value: function value(errors) {
          var _this14 = this;
          return errors.each(function (error) {
            var association, field, nestedError, nestedErrors, nestedField, ref, ref1;
            field = (nestedField = error.field.split(".")).shift(), _this14.push(error);
            try {
              return association = _this14.base.association(field), (nestedError = _.clone(error)).field = 0 === nestedField.length ? "base" : nestedField.join("."), nestedErrors = ActiveResource.Collection.build([nestedError]), association.reflection.collection() ? null != (ref = association.target.first()) ? ref.errors().propagate(nestedErrors) : void 0 : null != (ref1 = association.target) ? ref1.errors().propagate(nestedErrors) : void 0;
            } catch (error1) {}
          });
        }
      }, {
        key: "push",
        value: function value(error) {
          var base, name;
          return (base = this.__errors)[name = error.field] || (base[name] = []), this.__errors[error.field].push(error), error;
        }
      }, {
        key: "added",
        value: function value(field, code) {
          return null != ActiveResource.prototype.Collection.build(this.__errors[field]).detect(function (e) {
            return e.code === code;
          });
        }
      }, {
        key: "include",
        value: function value(field) {
          return null != this.__errors[field] && _.size(this.__errors[field]) > 0;
        }
      }, {
        key: "empty",
        value: function value() {
          return 0 === this.size();
        }
      }, {
        key: "size",
        value: function value() {
          return _.size(this.toArray());
        }
      }, {
        key: "delete",
        value: function value(field) {
          return this.__errors[field] = [];
        }
      }, {
        key: "each",
        value: function value(iterator) {
          return _.each(this.__errors, function (errors, field) {
            var error, i, len, results;
            for (results = [], i = 0, len = errors.length; i < len; i++) error = errors[i], results.push(iterator(field, error));
            return results;
          });
        }
      }, {
        key: "forField",
        value: function value(field) {
          var _this15 = this;
          return ActiveResource.prototype.Collection.build(_.keys(this.__errors)).select(function (k) {
            return s.startsWith(k, field);
          }).map(function (k) {
            return _this15.__errors[k];
          }).flatten();
        }
      }, {
        key: "detailsForField",
        value: function value(field) {
          return this.forField(field).inject({}, function (out, error) {
            return out[error.code] = error.detail, out;
          });
        }
      }, {
        key: "forBase",
        value: function value() {
          return this.forField("base");
        }
      }, {
        key: "toArray",
        value: function value() {
          var errors, field, output, ref;
          for (field in output = [], ref = this.__errors) {
            var _output;
            errors = ref[field], (_output = output).push.apply(_output, _toConsumableArray(errors));
          }
          return output;
        }
      }, {
        key: "toCollection",
        value: function value() {
          return ActiveResource.prototype.Collection.build(this.toArray());
        }
      }, {
        key: "__add",
        value: function value(field, code) {
          var base,
            error,
            detail = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : "";
          return (base = this.__errors)[field] || (base[field] = []), this.__errors[field].push(error = this.__buildError(field, code, detail)), error;
        }
      }, {
        key: "__buildError",
        value: function value(field, code, detail) {
          return {
            field: field,
            code: code,
            detail: detail,
            message: detail
          };
        }
      }]), Errors;
    }();
  }.call(void 0), function () {
    ActiveResource.prototype.Fields = function () {
      function Fields() {
        _classCallCheck(this, Fields);
      }
      return _createClass(Fields, [{
        key: "fields",
        value: function value() {
          var _output2, _output3, attributes, output;
          return attributes = this.attributes(), (_output2 = output = ActiveResource.prototype.Collection.build(attributes.all)).push.apply(_output2, _toConsumableArray(attributes.read.toArray())), (_output3 = output).push.apply(_output3, _toConsumableArray(_.keys(this.reflections()))), output;
        }
      }], [{
        key: "__initializeFields",
        value: function value() {
          var _this16 = this;
          return this.__fields = {}, this.klass().fields().each(function (field) {
            var ref;
            return (null != (ref = _this16.klass().reflectOnAssociation(field)) ? ref.collection() : void 0) ? _this16.__fields[field] = ActiveResource.prototype.Collection.build() : _this16.__fields[field] = null;
          });
        }
      }, {
        key: "__assignFields",
        value: function value(fields) {
          var _this17 = this;
          return _.each(fields, function (v, k) {
            if (_.has(_this17.__fields, k)) try {
              return _this17.association(k).reflection.collection() ? _this17.__fields[k] = ActiveResource.prototype.Collection.build(v) : _this17.__fields[k] = v;
            } catch (error) {
              return _this17.__fields[k] = v;
            }
          }), this.__assignAttributes(fields);
        }
      }, {
        key: "changed",
        value: function value() {
          return !this.changedFields().empty();
        }
      }, {
        key: "changedFields",
        value: function value() {
          var _this18 = this;
          return this.klass().fields().select(function (field) {
            var association, newField, oldField;
            oldField = _this18.__fields[field], newField = _this18[field];
            try {
              return association = _this18.association(field), newField = _this18[field](), association.reflection.collection() ? oldField.size() !== newField.size() || !newField.target().select(function (t) {
                return !oldField.include(t) || association.reflection.autosave() && t.changed();
              }).empty() : oldField != newField || association.reflection.autosave() && newField.changed();
            } catch (error) {
              return oldField != newField && !_.isUndefined(newField);
            }
          });
        }
      }]), Fields;
    }();
  }.call(void 0), function () {
    ActiveResource.Links = ActiveResource.prototype.Links = function () {
      function Links() {
        _classCallCheck(this, Links);
      }
      return _createClass(Links, [{
        key: "links",
        value: function value() {
          return this.__links || (this.__links = _.clone(this.klass().links()));
        }
      }], [{
        key: "links",
        value: function value() {
          if (null == this.resourceLibrary.baseUrl) throw "baseUrl is not set";
          if (null == this.queryName) throw "queryName is not set";
          return this.__links || (this.__links = {
            related: this.resourceLibrary.baseUrl + this.queryName + "/"
          });
        }
      }, {
        key: "__constructLink",
        value: function value() {
          for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) args[_key4] = arguments[_key4];
          return _.map(args, function (str) {
            return s.endsWith(str, "/") ? str : str + "/";
          }).join("");
        }
      }]), Links;
    }();
  }.call(void 0), function () {
    ActiveResource.prototype.Persistence = function () {
      function Persistence() {
        _classCallCheck(this, Persistence);
      }
      return _createClass(Persistence, null, [{
        key: "persisted",
        value: function value() {
          return null != this.links().self;
        }
      }, {
        key: "newResource",
        value: function value() {
          return !this.persisted();
        }
      }, {
        key: "save",
        value: function value(callback) {
          return this.__createOrUpdate().then(callback, callback);
        }
      }, {
        key: "update",
        value: function value(attributes, callback) {
          var attributesKeys, oldAttributes;
          return attributesKeys = ActiveResource.prototype.Collection.build(_.keys(attributes)), oldAttributes = _.pick(this.attributes(), attributesKeys.toArray()), oldAttributes = _.defaults(oldAttributes, attributesKeys.inject({}, function (obj, k) {
            return obj[k] = null, obj;
          })), this.__assignAttributes(attributes), this.__createOrUpdate().then(null, function (resource) {
            return resource.__assignAttributes(oldAttributes), resource;
          }).then(callback, callback);
        }
      }, {
        key: "destroy",
        value: function value() {
          var resource;
          return this.klass().resourceLibrary["interface"]["delete"](this.links().self, resource = this).then(function () {
            return resource.__links = {}, resource;
          });
        }
      }, {
        key: "__createOrUpdate",
        value: function value() {
          return this.errors().reset(), this.persisted() ? this.klass().resourceLibrary["interface"].patch(this.links().self, this) : this.klass().resourceLibrary["interface"].post(this.links().related, this);
        }
      }]), Persistence;
    }();
  }.call(void 0), function () {
    ActiveResource.prototype.QueryParams = function () {
      var COLLECTION_RELATED,
        RESOURCE_RELATED,
        QueryParams = function () {
          function QueryParams() {
            _classCallCheck(this, QueryParams);
          }
          return _createClass(QueryParams, null, [{
            key: "queryParams",
            value: function value() {
              return this.__queryParams || (this.__queryParams = ("function" == typeof this.isA ? this.isA(ActiveResource.prototype.Base) : void 0) ? _.clone(this.klass().queryParams()) : {});
            }
          }, {
            key: "queryParamsForReflection",
            value: function value(reflection) {
              var includes, queryParams, ref;
              return queryParams = {}, null != this.queryParams().include && 0 !== (includes = ActiveResource.prototype.Collection.build(this.queryParams().include).inject([], function (out, i) {
                return _.isObject(i) && _.each(_.keys(i), function (i2) {
                  if (i2 === reflection.name) return out.push.apply(out, _toConsumableArray(_.flatten([i[i2]])));
                }), out;
              })).length && (queryParams.include = includes), ("function" == typeof reflection.polymorphic ? reflection.polymorphic() : void 0) || null == (null != (ref = this.queryParams().fields) ? ref[reflection.klass().queryName] : void 0) || (queryParams.fields = _.pick(this.queryParams().fields, reflection.klass().queryName)), queryParams;
            }
          }, {
            key: "assignQueryParams",
            value: function value(queryParams) {
              return this.__queryParams = queryParams;
            }
          }, {
            key: "assignResourceRelatedQueryParams",
            value: function value(queryParams) {
              return this.assignQueryParams(_.pick.apply(_, [queryParams].concat(_toConsumableArray(RESOURCE_RELATED))));
            }
          }, {
            key: "resetQueryParams",
            value: function value() {
              return this.__queryParams = {};
            }
          }, {
            key: "__resourceRelatedParams",
            value: function value() {
              return _.pick.apply(_, [this.queryParams()].concat(_toConsumableArray(RESOURCE_RELATED)));
            }
          }, {
            key: "__collectionRelatedParams",
            value: function value() {
              return _.pick.apply(_, [this.queryParams()].concat(_toConsumableArray(COLLECTION_RELATED)));
            }
          }, {
            key: "__extendValueParam",
            value: function value(param, _value2, queryParams) {
              return queryParams || (queryParams = _.clone(this.queryParams())), queryParams[param] = _value2, queryParams;
            }
          }, {
            key: "__extendObjectParam",
            value: function value(param, options, queryParams) {
              return queryParams || (queryParams = _.clone(this.queryParams())), queryParams[param] = _.extend(queryParams[param] || {}, options), queryParams;
            }
          }, {
            key: "__extendArrayParam",
            value: function value(param, items, queryParams) {
              var _queryParams$param;
              (queryParams || (queryParams = _.clone(this.queryParams())), queryParams[param] = queryParams[param] ? queryParams[param].slice(0) : [], null != items) && (_queryParams$param = queryParams[param]).push.apply(_queryParams$param, _toConsumableArray(items));
              return queryParams;
            }
          }]), QueryParams;
        }();
      return RESOURCE_RELATED = ["fields", "include"], COLLECTION_RELATED = ["filter", "sort", "page"], QueryParams;
    }.call(this);
  }.call(void 0), function () {
    ActiveResource.Reflection = ActiveResource.prototype.Reflection = function () {
      var Reflection = function () {
        function Reflection() {
          _classCallCheck(this, Reflection);
        }
        return _createClass(Reflection, [{
          key: "reflections",
          value: function value() {
            return this.__reflections || (this.__reflections = {});
          }
        }, {
          key: "reflectOnAllAssociations",
          value: function value() {
            var reflections,
              macro = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : null;
            return reflections = ActiveResource.prototype.Collection.build(_.values(this.__reflections)), macro && (reflections = reflections.select(function (r) {
              return r.macro === macro;
            })), reflections;
          }
        }, {
          key: "reflectOnAssociation",
          value: function value(association) {
            return this.reflections()[association];
          }
        }, {
          key: "reflectOnAllAutosaveAssociations",
          value: function value() {
            return ActiveResource.prototype.Collection.build(_.values(this.__reflections)).select(function (r) {
              return "function" == typeof r.autosave ? r.autosave() : void 0;
            });
          }
        }], [{
          key: "create",
          value: function value(macro, name, options, activeResource) {
            return new (function () {
              switch (macro) {
                case "hasMany":
                  return Reflection.prototype.HasManyReflection;
                case "hasOne":
                  return Reflection.prototype.HasOneReflection;
                case "belongsTo":
                  return Reflection.prototype.BelongsToReflection;
              }
            }())(name, options, activeResource);
          }
        }, {
          key: "addReflection",
          value: function value(ar, name, reflection) {
            var r;
            return (r = {})[name] = reflection, ar.__reflections = _.extend(ar.__reflections || {}, r);
          }
        }]), Reflection;
      }();
      return Reflection.prototype.AbstractReflection = function () {
        var INVALID_AUTOMATIC_INVERSE_OPTIONS,
          VALID_AUTOMATIC_INVERSE_MACROS,
          automaticInverseOf,
          canFindInverseOfAutomatically,
          validInverseReflection,
          AbstractReflection = function () {
            function AbstractReflection(name1, options1, activeResource1) {
              _classCallCheck(this, AbstractReflection), this.name = name1, this.options = options1, this.activeResource = activeResource1, this.autosave() && this.activeResource.assignQueryParams(this.activeResource.__extendArrayParam("include", [this.name]));
            }
            return _createClass(AbstractReflection, [{
              key: "klass",
              value: function value() {
                return this.activeResource.resourceLibrary.constantize(this.className());
              }
            }, {
              key: "type",
              value: function value() {
                return this.__type || (this.__type = this.options.as && (this.options.foreignType || "".concat(this.options.as, "Type")));
              }
            }, {
              key: "className",
              value: function value() {
                return this.__className || (this.__className = this.options.className || this.__deriveClassName());
              }
            }, {
              key: "foreignKey",
              value: function value() {
                return this.__foreignKey || (this.__foreignKey = this.options.foreignKey || this.__deriveForeignKey());
              }
            }, {
              key: "foreignType",
              value: function value() {
                return this.__foreignType || (this.__foreignType = this.options.foreignType || "".concat(this.name, "Type"));
              }
            }, {
              key: "associationPrimaryKey",
              value: function value(klass) {
                return this.options.primaryKey || this.__primaryKey(klass || this.klass());
              }
            }, {
              key: "activeResourcePrimaryKey",
              value: function value() {
                return this.__activeResourcePrimaryKey || (this.__activeResourcePrimaryKey = this.options.primaryKey || this.__primaryKey(this.activeResource));
              }
            }, {
              key: "collection",
              value: function value() {
                return !1;
              }
            }, {
              key: "hasOne",
              value: function value() {
                return !1;
              }
            }, {
              key: "belongsTo",
              value: function value() {
                return !1;
              }
            }, {
              key: "constructable",
              value: function value() {
                return !0;
              }
            }, {
              key: "polymorphic",
              value: function value() {
                return this.options.polymorphic || !1;
              }
            }, {
              key: "autosave",
              value: function value() {
                return this.options.autosave || !1;
              }
            }, {
              key: "buildAssociation",
              value: function value() {
                return this.klass().build();
              }
            }, {
              key: "hasInverse",
              value: function value() {
                return null != this.__inverseName();
              }
            }, {
              key: "inverseOf",
              value: function value() {
                if (this.hasInverse()) return this.__inverseOf || (this.__inverseOf = this.klass().reflectOnAssociation(this.__inverseName()));
              }
            }, {
              key: "polymorphicInverseOf",
              value: function value(associatedClass) {
                var inverseRelationship;
                if (this.hasInverse() && (inverseRelationship = associatedClass.reflectOnAssociation(this.options.inverseOf))) return inverseRelationship;
              }
            }, {
              key: "__deriveClassName",
              value: function value() {
                return s.classify(_.singularize(this.name));
              }
            }, {
              key: "__deriveForeignKey",
              value: function value() {
                return this.belongsTo() ? "".concat(this.name, "Id") : this.options.as ? "".concat(this.options.as, "Id") : "".concat(s.camelize(this.activeResource.className, !0), "Id");
              }
            }, {
              key: "__primaryKey",
              value: function value(klass) {
                return klass.primaryKey || function () {
                  throw "Unknown primary key for ".concat(klass.className);
                }();
              }
            }, {
              key: "__inverseName",
              value: function value() {
                return this.options.inverseOf || (!1 === this.__automaticInverseOf ? null : this.__automaticInverseOf || (this.__automaticInverseOf = automaticInverseOf(this)));
              }
            }]), AbstractReflection;
          }();
        return ActiveResource.include(AbstractReflection, ActiveResource.prototype.Typing), AbstractReflection.__excludeFromExtend = !0, automaticInverseOf = function automaticInverseOf(reflection) {
          var inverseName, inverseReflection;
          if (canFindInverseOfAutomatically(reflection)) {
            inverseName = s.camelize(reflection.options.as || reflection.activeResource.className, !0);
            try {
              inverseReflection = reflection.klass().reflectOnAssociation(inverseName);
            } catch (error) {
              inverseReflection = !1;
            }
            if (validInverseReflection(reflection, inverseReflection)) return inverseName;
          }
          return !1;
        }, VALID_AUTOMATIC_INVERSE_MACROS = ["hasMany", "hasOne", "belongsTo"], INVALID_AUTOMATIC_INVERSE_OPTIONS = ["polymorphic"], canFindInverseOfAutomatically = function canFindInverseOfAutomatically(reflection) {
          return !1 !== reflection.options.inverseOf && _.include(VALID_AUTOMATIC_INVERSE_MACROS, reflection.macro) && _.isEmpty(_.pick.apply(_, [reflection.options].concat(_toConsumableArray(INVALID_AUTOMATIC_INVERSE_OPTIONS))));
        }, validInverseReflection = function validInverseReflection(reflection, inverseReflection) {
          return inverseReflection && reflection.klass().className === inverseReflection.activeResource.className && canFindInverseOfAutomatically(inverseReflection);
        }, AbstractReflection;
      }.call(this), Reflection.prototype.HasManyReflection = function () {
        var HasManyReflection = function (_Reflection$prototype) {
          function HasManyReflection() {
            return _classCallCheck(this, HasManyReflection), _possibleConstructorReturn(this, _getPrototypeOf(HasManyReflection).apply(this, arguments));
          }
          return _inherits(HasManyReflection, Reflection.prototype.AbstractReflection), _createClass(HasManyReflection, [{
            key: "collection",
            value: function value() {
              return !0;
            }
          }, {
            key: "associationClass",
            value: function value() {
              return ActiveResource.prototype.Associations.prototype.HasManyAssociation;
            }
          }]), HasManyReflection;
        }();
        return HasManyReflection.__excludeFromExtend = !0, HasManyReflection.prototype.macro = "hasMany", HasManyReflection;
      }.call(this), Reflection.prototype.HasOneReflection = function () {
        var HasOneReflection = function (_Reflection$prototype2) {
          function HasOneReflection() {
            return _classCallCheck(this, HasOneReflection), _possibleConstructorReturn(this, _getPrototypeOf(HasOneReflection).apply(this, arguments));
          }
          return _inherits(HasOneReflection, Reflection.prototype.AbstractReflection), _createClass(HasOneReflection, [{
            key: "hasOne",
            value: function value() {
              return !0;
            }
          }, {
            key: "associationClass",
            value: function value() {
              return ActiveResource.prototype.Associations.prototype.HasOneAssociation;
            }
          }]), HasOneReflection;
        }();
        return HasOneReflection.__excludeFromExtend = !0, HasOneReflection.prototype.macro = "hasOne", HasOneReflection;
      }.call(this), Reflection.prototype.BelongsToReflection = function () {
        var BelongsToReflection = function (_Reflection$prototype3) {
          function BelongsToReflection() {
            return _classCallCheck(this, BelongsToReflection), _possibleConstructorReturn(this, _getPrototypeOf(BelongsToReflection).apply(this, arguments));
          }
          return _inherits(BelongsToReflection, Reflection.prototype.AbstractReflection), _createClass(BelongsToReflection, [{
            key: "belongsTo",
            value: function value() {
              return !0;
            }
          }, {
            key: "constructable",
            value: function value() {
              return !this.polymorphic();
            }
          }, {
            key: "associationClass",
            value: function value() {
              return this.polymorphic() ? ActiveResource.prototype.Associations.prototype.BelongsToPolymorphicAssociation : ActiveResource.prototype.Associations.prototype.BelongsToAssociation;
            }
          }]), BelongsToReflection;
        }();
        return BelongsToReflection.__excludeFromExtend = !0, BelongsToReflection.prototype.macro = "belongsTo", BelongsToReflection;
      }.call(this), Reflection;
    }.call(this);
  }.call(void 0), function () {
    ActiveResource.Relation = ActiveResource.prototype.Relation = function () {
      var Relation = function () {
        function Relation(base, __queryParams) {
          var INTERNAL_METHODS,
            classMethods,
            customClassMethods,
            mixin,
            _this19 = this;
          _classCallCheck(this, Relation), this.base = base, this.__queryParams = __queryParams, this.queryName = this.base.queryName, this.base.isA(Function) && (INTERNAL_METHODS = ["arguments", "caller", "length", "name", "prototype", "__super__", "className", "queryName", "resourceLibrary", "__attributes", "__callbacks", "__links", "__reflections", "__queryParams"], classMethods = _.difference(Object.getOwnPropertyNames(this.base), _.keys(ActiveResource.prototype.Base)), customClassMethods = _.difference(classMethods, INTERNAL_METHODS), mixin = ActiveResource.Collection.build(customClassMethods).inject({}, function (obj, method) {
            return obj[method] = _this19.base[method], obj;
          }), ActiveResource.extend(this, mixin));
        }
        return _createClass(Relation, [{
          key: "links",
          value: function value() {
            return this.base.links();
          }
        }, {
          key: "interface",
          value: function value() {
            return this.base["interface"]();
          }
        }, {
          key: "where",
          value: function value(options) {
            return this.__newRelation(this.__extendObjectParam("filter", options));
          }
        }, {
          key: "order",
          value: function value(args) {
            return this.__newRelation(this.__extendObjectParam("sort", args));
          }
        }, {
          key: "select",
          value: function value() {
            var queryParams,
              _this20 = this;
            (queryParams = _.clone(this.queryParams())).fields || (queryParams.fields = {}), queryParams.__root || (queryParams.__root = this.queryName);
            for (var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) args[_key5] = arguments[_key5];
            return ActiveResource.prototype.Collection.build(args).map(function (a) {
              var i, key, len, ref, results;
              if (_.isObject(a)) {
                for (results = [], i = 0, len = (ref = _.keys(a)).length; i < len; i++) key = ref[i], results.push(_.pick(a, key));
                return results;
              }
              return a;
            }).flatten().each(function (arg) {
              var modelName;
              return modelName = _.isObject(arg) ? _.keys(arg)[0] : queryParams.__root, queryParams.fields = _this20.__extendArrayParam(modelName, _.isObject(arg) ? [_.values(arg)[0]] : [arg], queryParams.fields);
            }), this.__newRelation(queryParams);
          }
        }, {
          key: "page",
          value: function value(_value3) {
            return this.__newRelation(this.__extendObjectParam("page", {
              number: _value3
            }));
          }
        }, {
          key: "perPage",
          value: function value(_value4) {
            return this.__newRelation(this.__extendObjectParam("page", {
              size: _value4
            }));
          }
        }, {
          key: "limit",
          value: function value(_value5) {
            return this.__newRelation(this.__extendValueParam("limit", _value5));
          }
        }, {
          key: "offset",
          value: function value(_value6) {
            return this.__newRelation(this.__extendValueParam("offset", _value6));
          }
        }, {
          key: "includes",
          value: function value() {
            for (var _len6 = arguments.length, args = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++) args[_key6] = arguments[_key6];
            return args = ActiveResource.prototype.Collection.build(args).map(function (a) {
              var i, key, len, ref, results;
              if (_.isObject(a)) {
                for (results = [], i = 0, len = (ref = _.keys(a)).length; i < len; i++) key = ref[i], results.push(_.pick(a, key));
                return results;
              }
              return a;
            }).flatten().toArray(), this.__newRelation(this.__extendArrayParam("include", args));
          }
        }, {
          key: "build",
          value: function value() {
            var resource,
              attributes = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
            return (resource = null != this.base ? new this.base() : new this()).__assignAttributes(_.extend(attributes, this.queryParams().filter)), resource.assignResourceRelatedQueryParams(this.queryParams()), resource.__executeCallbacks("afterBuild"), resource;
          }
        }, {
          key: "create",
          value: function value() {
            var attributes = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
              callback = arguments.length > 1 ? arguments[1] : void 0;
            return this.build(attributes).save(callback);
          }
        }, {
          key: "find",
          value: function value(primaryKey) {
            var url;
            if (null != primaryKey) return url = ActiveResource.prototype.Links.__constructLink(this.links().related, primaryKey.toString()), this["interface"]().get(url, this.queryParams());
          }
        }, {
          key: "findBy",
          value: function value(conditions) {
            return this.where(conditions).first();
          }
        }, {
          key: "all",
          value: function value() {
            return this["interface"]().get(this.links().related, this.queryParams());
          }
        }, {
          key: "each",
          value: function value(iteratee) {
            return this.all().then(function (collection) {
              return collection.each(iteratee), collection;
            });
          }
        }, {
          key: "first",
          value: function value(n) {
            return (null != this.queryParams().page ? this : this.limit(n || 1)).all().then(function (collection) {
              return collection.first(n);
            });
          }
        }, {
          key: "last",
          value: function value(n) {
            return (null != this.queryParams().page ? this : this.offset(-(n || 1)).limit(n || 1)).all().then(function (collection) {
              return collection.last(n);
            });
          }
        }, {
          key: "__newRelation",
          value: function value(queryParams) {
            return new this.constructor(this.base, queryParams);
          }
        }]), Relation;
      }();
      return ActiveResource.include(Relation, ActiveResource.prototype.QueryParams), ActiveResource.include(Relation, ActiveResource.prototype.Typing), Relation;
    }.call(this);
  }.call(void 0), function () {
    ActiveResource.prototype.Core = function () {
      var Core = function () {
        function Core() {
          _classCallCheck(this, Core);
        }
        return _createClass(Core, [{
          key: "interface",
          value: function value() {
            return this.klass()["interface"]();
          }
        }, {
          key: "toString",
          value: function value() {
            return JSON.stringify(this["interface"]().buildResourceDocument({
              resourceData: this
            }));
          }
        }], [{
          key: "interface",
          value: function value() {
            return this.resourceLibrary["interface"];
          }
        }, {
          key: "__newRelation",
          value: function value(queryParams) {
            return new ActiveResource.prototype.Relation(this, queryParams);
          }
        }]), Core;
      }();
      return Core.primaryKey = "id", Core;
    }.call(this);
  }.call(void 0), function () {
    ActiveResource.prototype.Base = function () {
      var Base = function Base() {
        _classCallCheck(this, Base), this.__initializeFields();
      };
      return ActiveResource.extend(Base, ActiveResource.prototype.Associations), ActiveResource.extend(Base, ActiveResource.prototype.Attributes.prototype), ActiveResource.extend(Base, ActiveResource.prototype.Callbacks.prototype), ActiveResource.extend(Base, ActiveResource.prototype.Core), ActiveResource.extend(Base, ActiveResource.prototype.Fields.prototype), ActiveResource.extend(Base, ActiveResource.prototype.Links), ActiveResource.extend(Base, ActiveResource.prototype.Reflection.prototype), ActiveResource.extend(Base, ActiveResource.prototype.Relation.prototype), ActiveResource.include(Base, ActiveResource.prototype.Associations.prototype), ActiveResource.include(Base, ActiveResource.prototype.Core.prototype), ActiveResource.include(Base, ActiveResource.prototype.Attributes), ActiveResource.include(Base, ActiveResource.prototype.Callbacks), ActiveResource.include(Base, ActiveResource.prototype.Cloning), ActiveResource.include(Base, ActiveResource.prototype.Errors), ActiveResource.include(Base, ActiveResource.prototype.Fields), ActiveResource.include(Base, ActiveResource.prototype.Links.prototype), ActiveResource.include(Base, ActiveResource.prototype.Persistence), ActiveResource.include(Base, ActiveResource.prototype.QueryParams), ActiveResource.include(Base, ActiveResource.prototype.Typing), Base;
    }.call(this);
  }.call(void 0), function () {
    ActiveResource.prototype.Associations.prototype.Association = function () {
      var Association = function () {
        function Association(owner, reflection) {
          _classCallCheck(this, Association), this.owner = owner, this.reflection = reflection, this.reset();
        }
        return _createClass(Association, [{
          key: "klass",
          value: function value() {
            return this.reflection.klass();
          }
        }, {
          key: "options",
          value: function value() {
            return this.reflection.options;
          }
        }, {
          key: "links",
          value: function value() {
            return this.__links || (this.__links = _.clone(this.klass().links()));
          }
        }, {
          key: "interface",
          value: function value() {
            return this.owner.klass()["interface"]();
          }
        }, {
          key: "reset",
          value: function value() {
            return this.__loaded = !1, this.target = null;
          }
        }, {
          key: "reload",
          value: function value() {
            var _this;
            return this.reset(), _this = this, this.loadTarget().then(function () {
              return _this;
            });
          }
        }, {
          key: "loaded",
          value: function value() {
            return arguments.length > 0 && void 0 !== arguments[0] && arguments[0] && (this.__loaded = !0), this.__loaded;
          }
        }, {
          key: "loadTarget",
          value: function value() {
            var _this21 = this;
            return this.__canFindTarget() ? this.__findTarget().then(function (loadedTarget) {
              return _this21.target = loadedTarget, _this21.loaded(!0), loadedTarget;
            })["catch"](function () {
              return _this21.reset();
            }) : (this.reset(), null);
          }
        }, {
          key: "setInverseInstance",
          value: function value(resource) {
            var inverse;
            return this.__invertibleFor(resource) && ((inverse = resource.association(this.__inverseReflectionFor(resource).name)).reflection.collection() ? inverse.addToTarget(this.owner) : inverse.target = this.owner), resource;
          }
        }, {
          key: "__raiseOnTypeMismatch",
          value: function value(resource) {
            if (!("function" == typeof resource.isA ? resource.isA(this.reflection.klass()) : void 0)) throw "".concat(this.reflection.className(), " expected, got ").concat(resource, " which is an instance of ").concat(resource.constructor);
          }
        }, {
          key: "__canFindTarget",
          value: function value() {
            return (!this.owner.newResource() || this.__foreignKeyPresent()) && this.klass();
          }
        }, {
          key: "__creationAttributes",
          value: function value() {
            var attributes, base, base1;
            return attributes = {}, (("function" == typeof (base = this.reflection).hasOne ? base.hasOne() : void 0) || ("function" == typeof (base1 = this.reflection).collection ? base1.collection() : void 0)) && (attributes[this.reflection.foreignKey()] = this.owner[this.reflection.activeResourcePrimaryKey()], this.reflection.options.as && (attributes[this.reflection.type()] = this.owner.klass().className)), attributes;
          }
        }, {
          key: "__executeOnCloneIfImmutable",
          value: function value(checkImmutable, _value7, fn) {
            var clone,
              newValue,
              result,
              _this22 = this;
            return checkImmutable && this.owner.klass().resourceLibrary.immutable ? (clone = this.owner.clone(), newValue = ActiveResource.Collection.build(_value7).map(function (val) {
              return (null != val ? val.__createClone({
                cloner: _this22.owner,
                newCloner: clone
              }) : void 0) || null;
            }), null != (result = _.bind(fn, clone.association(this.reflection.name))((("function" == typeof _value7.isA ? _value7.isA(ActiveResource.Collection) : void 0) || _.isArray(_value7)) && newValue.toArray() || newValue.first())).then ? result.then(function () {
              return clone;
            }) : clone) : _.bind(fn, this)(_value7);
          }
        }, {
          key: "__setOwnerAttributes",
          value: function value(resource) {
            var key, ref, results, value;
            for (key in results = [], ref = this.__creationAttributes()) value = ref[key], results.push(resource[key] = value);
            return results;
          }
        }, {
          key: "__foreignKeyPresent",
          value: function value() {
            return !1;
          }
        }, {
          key: "__inverseReflectionFor",
          value: function value(resource) {
            return this.reflection.inverseOf();
          }
        }, {
          key: "__invertibleFor",
          value: function value(resource) {
            return null != this.__inverseReflectionFor(resource);
          }
        }, {
          key: "__foreignKeyFor",
          value: function value(resource) {
            return "function" == typeof resource.hasAttribute ? resource.hasAttribute(this.reflection.foreignKey()) : void 0;
          }
        }, {
          key: "__buildResource",
          value: function value(attributes) {
            var resource;
            return (resource = this.reflection.buildAssociation()).__assignAttributes(attributes), resource;
          }
        }]), Association;
      }();
      return ActiveResource.include(Association, ActiveResource.prototype.Typing), Association.__excludeFromExtend = !0, Association;
    }.call(this);
  }.call(void 0), function () {
    ActiveResource.prototype.Associations.prototype.CollectionAssociation = function (_ActiveResource$proto3) {
      function CollectionAssociation(owner, reflection) {
        var _this23;
        return _classCallCheck(this, CollectionAssociation), (_this23 = _possibleConstructorReturn(this, _getPrototypeOf(CollectionAssociation).apply(this, arguments))).owner = owner, _this23.reflection = reflection, _this23.queryName = _this23.klass().queryName, _this23;
      }
      return _inherits(CollectionAssociation, ActiveResource.prototype.Associations.prototype.Association), _createClass(CollectionAssociation, [{
        key: "reader",
        value: function value() {
          return this.proxy || (this.proxy = new ActiveResource.prototype.Associations.prototype.CollectionProxy(this));
        }
      }, {
        key: "writer",
        value: function value(resources) {
          var save = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1],
            checkImmutable = arguments.length > 2 && void 0 !== arguments[2] && arguments[2];
          return this.__executeOnCloneIfImmutable(checkImmutable, resources, function (resources) {
            var base,
              localAssignment,
              persistedResources,
              _this24 = this;
            return (resources = ActiveResource.prototype.Collection.build(resources)).each(function (r) {
              return _this24.__raiseOnTypeMismatch(r);
            }), persistedResources = resources.select(function (r) {
              return "function" == typeof r.persisted ? r.persisted() : void 0;
            }), localAssignment = function localAssignment() {
              return save && _this24.loaded(!0), _this24.replace(resources), resources;
            }, !save || ("function" == typeof (base = this.owner).newResource ? base.newResource() : void 0) || !resources.empty() && persistedResources.empty() ? localAssignment() : this.__persistAssignment(persistedResources.toArray()).then(localAssignment);
          });
        }
      }, {
        key: "build",
        value: function value() {
          var attributes = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
          return this.__executeOnCloneIfImmutable(!0, [], function () {
            var _this25 = this;
            return _.isArray(attributes) ? ActiveResource.prototype.Collection.build(attributes).map(function (attr) {
              return _this25.build(attr);
            }) : this.__concatResources(ActiveResource.prototype.Collection.build(this.__buildResource(attributes))).first();
          });
        }
      }, {
        key: "create",
        value: function value() {
          var attributes = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
            queryParams = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
            callback = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : _.noop();
          return this.__executeOnCloneIfImmutable(!0, [], function () {
            return this.__createResource(attributes, queryParams, callback);
          });
        }
      }, {
        key: "concat",
        value: function value(resources) {
          return this.__executeOnCloneIfImmutable(!0, resources, function () {
            var base,
              persistedResources,
              _this26 = this;
            return (resources = ActiveResource.prototype.Collection.build(resources)).each(function (r) {
              return _this26.__raiseOnTypeMismatch(r);
            }), !("function" == typeof (base = this.owner).newResource ? base.newResource() : void 0) && (persistedResources = resources.select(function (r) {
              return "function" == typeof r.persisted ? r.persisted() : void 0;
            })).size() ? this.__persistConcat(persistedResources.toArray()).then(function () {
              return _this26.__concatResources(resources);
            }) : this.__concatResources(resources);
          });
        }
      }, {
        key: "delete",
        value: function value(resources) {
          return this.__executeOnCloneIfImmutable(!0, resources, function () {
            var base,
              persistedResources,
              _this27 = this;
            return (resources = ActiveResource.prototype.Collection.build(resources)).each(function (r) {
              return _this27.__raiseOnTypeMismatch(r);
            }), !("function" == typeof (base = this.owner).newResource ? base.newResource() : void 0) && (persistedResources = resources.select(function (r) {
              return "function" == typeof r.persisted ? r.persisted() : void 0;
            })).size() ? this.__persistDelete(persistedResources.toArray()).then(function () {
              return _this27.__removeResources(resources);
            }) : this.__removeResources(resources);
          });
        }
      }, {
        key: "reset",
        value: function value() {
          return _get(_getPrototypeOf(CollectionAssociation.prototype), "reset", this).call(this), this.target = ActiveResource.prototype.Collection.build();
        }
      }, {
        key: "addToTarget",
        value: function value(resource) {
          var index;
          return (index = _.indexOf(this.target.toArray(), resource)) < 0 && (index = null), this.replaceOnTarget(resource, index);
        }
      }, {
        key: "replaceOnTarget",
        value: function value(resource, index) {
          return null != index ? this.target.set(index, resource) : this.target.push(resource), this.setInverseInstance(resource), resource;
        }
      }, {
        key: "empty",
        value: function value() {
          return this.target.empty();
        }
      }, {
        key: "__findTarget",
        value: function value() {
          var _this;
          return _this = this, this["interface"]().get(this.links().related, this.owner.queryParamsForReflection(this.reflection)).then(function (resources) {
            return resources.each(function (r) {
              return _this.setInverseInstance(r);
            }), resources;
          });
        }
      }, {
        key: "replace",
        value: function value(other) {
          return this.__removeResources(this.target), this.__concatResources(other);
        }
      }, {
        key: "__concatResources",
        value: function value(resources) {
          var _this28 = this;
          return resources.each(function (resource) {
            return _this28.addToTarget(resource), _this28.insertResource(resource);
          }), resources;
        }
      }, {
        key: "__removeResources",
        value: function value(resources) {
          return this.__deleteResources(resources);
        }
      }, {
        key: "__deleteResources",
        value: function value(resources) {
          throw "__deleteResources not implemented on CollectionAssociation";
        }
      }, {
        key: "__persistAssignment",
        value: function value(resources) {
          return this["interface"]().patch(this.links().self, resources, {
            onlyResourceIdentifiers: !0
          });
        }
      }, {
        key: "__persistConcat",
        value: function value(resources) {
          return this["interface"]().post(this.links().self, resources, {
            onlyResourceIdentifiers: !0
          });
        }
      }, {
        key: "__persistDelete",
        value: function value(resources) {
          return this["interface"]()["delete"](this.links().self, resources, {
            onlyResourceIdentifiers: !0
          });
        }
      }, {
        key: "__createResource",
        value: function value(attributes, queryParams, callback) {
          var _this, base, resource;
          if (!("function" == typeof (base = this.owner).persisted ? base.persisted() : void 0)) throw "You cannot call create on an association unless the parent is saved";
          return (resource = this.__buildResource(attributes)).assignQueryParams(queryParams), this.insertResource(resource), _this = this, resource.save(callback).then(function () {
            return _this.addToTarget(resource), resource;
          });
        }
      }]), CollectionAssociation;
    }();
  }.call(void 0), function () {
    ActiveResource.prototype.Associations.prototype.CollectionProxy = function () {
      var CollectionProxy = function (_ActiveResource$proto4) {
        function CollectionProxy() {
          return _classCallCheck(this, CollectionProxy), _possibleConstructorReturn(this, _getPrototypeOf(CollectionProxy).apply(this, arguments));
        }
        return _inherits(CollectionProxy, ActiveResource.prototype.Relation), _createClass(CollectionProxy, [{
          key: "target",
          value: function value() {
            return this.base.target;
          }
        }, {
          key: "queryParams",
          value: function value() {
            var _this29 = this;
            return this.__queryParams || (this.__queryParams = function () {
              var base, klassQueryParams, queryParams;
              return queryParams = _.clone(_this29.base.owner.queryParamsForReflection(_this29.base.reflection)), ("function" == typeof (base = _this29.base.reflection).polymorphic ? base.polymorphic() : void 0) || (null != (klassQueryParams = _.clone(_this29.base.klass().queryParams())).include && (queryParams = _this29.__extendArrayParam("include", klassQueryParams.include, queryParams)), null != klassQueryParams.fields && _.each(klassQueryParams.fields, function (v, k) {
                var v2, _v;
                return (v2 = queryParams.fields[k]) ? (_v = v2).push.apply(_v, _toConsumableArray(v)) : queryParams.fields[k] = v;
              })), queryParams;
            }());
          }
        }, {
          key: "all",
          value: function value() {
            return (arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}).cached ? this.target() : _get(_getPrototypeOf(CollectionProxy.prototype), "all", this).call(this);
          }
        }, {
          key: "load",
          value: function value() {
            var _this30 = this;
            return this.all().then(function (collection) {
              return _this30.base.writer(collection, !1, !0);
            });
          }
        }, {
          key: "toArray",
          value: function value() {
            return this.all({
              cached: !0
            }).toArray();
          }
        }, {
          key: "size",
          value: function value() {
            return this.target().size();
          }
        }, {
          key: "empty",
          value: function value() {
            return this.target().empty();
          }
        }, {
          key: "assign",
          value: function value(other) {
            var save = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1];
            return this.base.writer(other, save, !0);
          }
        }, {
          key: "push",
          value: function value(resources) {
            return this.base.concat(resources);
          }
        }, {
          key: "build",
          value: function value() {
            var resources,
              _this31 = this,
              attributes = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
            return attributes = _.isArray(attributes) ? _.map(attributes, function (attr) {
              return _.extend(attr, _this31.queryParams().filter);
            }) : _.extend(attributes, this.queryParams().filter), (resources = ActiveResource.prototype.Collection.build(this.base.build(attributes))).each(function (r) {
              return r.assignResourceRelatedQueryParams(_this31.queryParams());
            }), resources.size() > 1 ? resources : resources.first();
          }
        }, {
          key: "create",
          value: function value() {
            var attributes = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
              callback = arguments.length > 1 ? arguments[1] : void 0;
            return attributes = _.extend(attributes, this.queryParams().filter), this.base.create(attributes, this.__resourceRelatedParams(), callback);
          }
        }, {
          key: "reload",
          value: function value() {
            return this.base.reload();
          }
        }, {
          key: "delete",
          value: function value(resources) {
            return this.base["delete"](resources);
          }
        }, {
          key: "deleteAll",
          value: function value() {
            return this.base["delete"](this.target());
          }
        }]), CollectionProxy;
      }();
      return CollectionProxy.__excludeFromExtend = !0, CollectionProxy;
    }.call(this);
  }.call(void 0), function () {
    ActiveResource.prototype.Associations.prototype.HasManyAssociation = function (_ActiveResource$proto5) {
      function HasManyAssociation() {
        return _classCallCheck(this, HasManyAssociation), _possibleConstructorReturn(this, _getPrototypeOf(HasManyAssociation).apply(this, arguments));
      }
      return _inherits(HasManyAssociation, ActiveResource.prototype.Associations.prototype.CollectionAssociation), _createClass(HasManyAssociation, [{
        key: "insertResource",
        value: function value(resource) {
          return this.__setOwnerAttributes(resource), this.setInverseInstance(resource);
        }
      }, {
        key: "__deleteResources",
        value: function value(resources) {
          var _this32 = this;
          return resources.each(function (resource) {
            var inverse;
            return null != (inverse = _this32.reflection.inverseOf()) ? resource.association(inverse.name).replace(null) : resource[_this32.reflection.foreignKey()] = null;
          }), this.target = ActiveResource.prototype.Collection.build(_.difference(this.target.toArray(), resources.toArray()));
        }
      }]), HasManyAssociation;
    }();
  }.call(void 0), function () {
    ActiveResource.prototype.Associations.prototype.SingularAssociation = function (_ActiveResource$proto6) {
      function SingularAssociation() {
        return _classCallCheck(this, SingularAssociation), _possibleConstructorReturn(this, _getPrototypeOf(SingularAssociation).apply(this, arguments));
      }
      return _inherits(SingularAssociation, ActiveResource.prototype.Associations.prototype.Association), _createClass(SingularAssociation, [{
        key: "reader",
        value: function value() {
          return this.target;
        }
      }, {
        key: "writer",
        value: function value(resource) {
          var save = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1],
            checkImmutable = arguments.length > 2 && void 0 !== arguments[2] && arguments[2];
          return this.__executeOnCloneIfImmutable(checkImmutable, resource, function (resource) {
            var base,
              localAssignment,
              _this33 = this;
            return null != resource && this.__raiseOnTypeMismatch(resource), localAssignment = function localAssignment() {
              return save && _this33.loaded(!0), _this33.replace(resource);
            }, save && !("function" == typeof (base = this.owner).newResource ? base.newResource() : void 0) ? this.__persistAssignment(resource).then(localAssignment) : localAssignment();
          });
        }
      }, {
        key: "build",
        value: function value() {
          var attributes = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
          return this.__executeOnCloneIfImmutable(!0, [], function () {
            var resource;
            return resource = this.__buildResource(attributes), this.replace(resource), resource;
          });
        }
      }, {
        key: "create",
        value: function value() {
          var attributes = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
            queryParams = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
            callback = arguments.length > 2 ? arguments[2] : void 0;
          return this.__executeOnCloneIfImmutable(!0, [], function () {
            return this.__createResource(attributes, queryParams, callback);
          });
        }
      }, {
        key: "replace",
        value: function value(resource) {
          return raise("Subclasses must implement a replace(resource) method");
        }
      }, {
        key: "__persistAssignment",
        value: function value(resource) {
          return this["interface"]().patch(this.links().self, resource, {
            onlyResourceIdentifiers: !0
          });
        }
      }, {
        key: "__getResource",
        value: function value() {
          return this["interface"]().get(this.links().related, this.owner.queryParamsForReflection(this.reflection));
        }
      }, {
        key: "__findTarget",
        value: function value() {
          var _this;
          return _this = this, this.__getResource().then(function (resource) {
            return _this.setInverseInstance(resource);
          });
        }
      }, {
        key: "__createResource",
        value: function value(attributes, queryParams, callback) {
          var _this, base, resource;
          if (!("function" == typeof (base = this.owner).persisted ? base.persisted() : void 0)) throw "You cannot call create on an association unless the parent is saved";
          return (resource = this.__buildResource(attributes)).assignQueryParams(queryParams), this.replace(resource), _this = this, resource.save(callback).then(function () {
            return _this.loaded(!0), resource;
          });
        }
      }]), SingularAssociation;
    }();
  }.call(void 0), function () {
    ActiveResource.prototype.Associations.prototype.HasOneAssociation = function (_ActiveResource$proto7) {
      function HasOneAssociation() {
        return _classCallCheck(this, HasOneAssociation), _possibleConstructorReturn(this, _getPrototypeOf(HasOneAssociation).apply(this, arguments));
      }
      return _inherits(HasOneAssociation, ActiveResource.prototype.Associations.prototype.SingularAssociation), _createClass(HasOneAssociation, [{
        key: "replace",
        value: function value(resource) {
          if (this.__removeTarget(), resource) return this.__setOwnerAttributes(resource), this.setInverseInstance(resource), this.target = resource;
        }
      }, {
        key: "__removeTarget",
        value: function value() {
          return this.target && this.__nullifyOwnerAttributes(this.target), this.target = null;
        }
      }, {
        key: "__nullifyOwnerAttributes",
        value: function value(resource) {
          return resource[this.reflection.foreignKey()] = null;
        }
      }]), HasOneAssociation;
    }();
  }.call(void 0), function () {
    ActiveResource.prototype.Associations.prototype.BelongsToAssociation = function (_ActiveResource$proto8) {
      function BelongsToAssociation() {
        return _classCallCheck(this, BelongsToAssociation), _possibleConstructorReturn(this, _getPrototypeOf(BelongsToAssociation).apply(this, arguments));
      }
      return _inherits(BelongsToAssociation, ActiveResource.prototype.Associations.prototype.SingularAssociation), _createClass(BelongsToAssociation, [{
        key: "reset",
        value: function value() {
          return _get(_getPrototypeOf(BelongsToAssociation.prototype), "reset", this).call(this), this.updated = !1;
        }
      }, {
        key: "replace",
        value: function value(resource) {
          return resource ? (this.__replaceKeys(resource), this.setInverseInstance(resource), this.updated = !0) : this.__removeKeys(), this.target = resource;
        }
      }, {
        key: "__getResource",
        value: function value() {
          return this.owner.newResource() ? this["interface"]().get(this.links().related + this.owner[this.reflection.foreignKey()], this.owner.queryParamsForReflection(this.reflection)) : _get(_getPrototypeOf(BelongsToAssociation.prototype), "__getResource", this).call(this);
        }
      }, {
        key: "__replaceKeys",
        value: function value(resource) {
          return this.owner[this.reflection.foreignKey()] = resource.__readAttribute(this.reflection.associationPrimaryKey(resource.klass()));
        }
      }, {
        key: "__removeKeys",
        value: function value() {
          return this.owner[this.reflection.foreignKey()] = null;
        }
      }, {
        key: "__foreignKeyPresent",
        value: function value() {
          return null != this.owner.__readAttribute(this.reflection.foreignKey());
        }
      }]), BelongsToAssociation;
    }();
  }.call(void 0), function () {
    ActiveResource.prototype.Associations.prototype.BelongsToPolymorphicAssociation = function (_ActiveResource$proto9) {
      function BelongsToPolymorphicAssociation() {
        return _classCallCheck(this, BelongsToPolymorphicAssociation), _possibleConstructorReturn(this, _getPrototypeOf(BelongsToPolymorphicAssociation).apply(this, arguments));
      }
      return _inherits(BelongsToPolymorphicAssociation, ActiveResource.prototype.Associations.prototype.BelongsToAssociation), _createClass(BelongsToPolymorphicAssociation, [{
        key: "klass",
        value: function value() {
          var type;
          type = this.owner[this.reflection.foreignType()];
          try {
            return this.owner.klass().resourceLibrary.constantize(type);
          } catch (error) {
            return;
          }
        }
      }, {
        key: "links",
        value: function value() {
          return this.klass() ? _get(_getPrototypeOf(BelongsToPolymorphicAssociation.prototype), "links", this).call(this) : {};
        }
      }, {
        key: "__replaceKeys",
        value: function value(resource) {
          return _get(_getPrototypeOf(BelongsToPolymorphicAssociation.prototype), "__replaceKeys", this).call(this, resource), this.owner[this.reflection.foreignType()] = resource.klass().className;
        }
      }, {
        key: "__removeKeys",
        value: function value() {
          return _get(_getPrototypeOf(BelongsToPolymorphicAssociation.prototype), "__removeKeys", this).call(this), this.owner[this.reflection.foreignType()] = null;
        }
      }, {
        key: "__inverseReflectionFor",
        value: function value(resource) {
          return this.reflection.polymorphicInverseOf(resource.klass());
        }
      }, {
        key: "__raiseOnTypeMismatch",
        value: function value(resource) {}
      }]), BelongsToPolymorphicAssociation;
    }();
  }.call(void 0), function () {
    ActiveResource.prototype.Associations.prototype.Builder = function () {
      var Builder = function Builder() {
        _classCallCheck(this, Builder);
      };
      return Builder.__excludeFromExtend = !0, Builder.prototype.Association = function () {
        function Association() {
          _classCallCheck(this, Association);
        }
        return _createClass(Association, null, [{
          key: "build",
          value: function value(model, name, options) {
            var reflection;
            return reflection = ActiveResource.prototype.Reflection.create(this.macro, name, options, model), this.defineAccessors(model, reflection), reflection;
          }
        }, {
          key: "defineAccessors",
          value: function value(model, reflection) {
            var name;
            return name = reflection.name, this.defineReaders(model, name), this.defineWriters(model, name);
          }
        }, {
          key: "defineReaders",
          value: function value(mixin, name) {
            return mixin.prototype[name] = function () {
              return this.association(name).reader();
            }, mixin.prototype["load".concat(s.capitalize(name))] = function () {
              return this.association(name).loadTarget();
            };
          }
        }, {
          key: "defineWriters",
          value: function value(mixin, name) {
            return _.noop();
          }
        }]), Association;
      }(), Builder;
    }.call(this);
  }.call(void 0), function () {
    ActiveResource.prototype.Associations.prototype.Builder.prototype.CollectionAssociation = function (_ActiveResource$proto10) {
      function CollectionAssociation() {
        return _classCallCheck(this, CollectionAssociation), _possibleConstructorReturn(this, _getPrototypeOf(CollectionAssociation).apply(this, arguments));
      }
      return _inherits(CollectionAssociation, ActiveResource.prototype.Associations.prototype.Builder.prototype.Association), CollectionAssociation;
    }();
  }.call(void 0), function () {
    ActiveResource.prototype.Associations.prototype.Builder.prototype.HasMany = function () {
      var HasMany = function (_ActiveResource$proto11) {
        function HasMany() {
          return _classCallCheck(this, HasMany), _possibleConstructorReturn(this, _getPrototypeOf(HasMany).apply(this, arguments));
        }
        return _inherits(HasMany, ActiveResource.prototype.Associations.prototype.Builder.prototype.CollectionAssociation), HasMany;
      }();
      return HasMany.macro = "hasMany", HasMany;
    }.call(this);
  }.call(void 0), function () {
    ActiveResource.prototype.Associations.prototype.Builder.prototype.SingularAssociation = function (_ActiveResource$proto12) {
      function SingularAssociation() {
        return _classCallCheck(this, SingularAssociation), _possibleConstructorReturn(this, _getPrototypeOf(SingularAssociation).apply(this, arguments));
      }
      return _inherits(SingularAssociation, ActiveResource.prototype.Associations.prototype.Builder.prototype.Association), _createClass(SingularAssociation, null, [{
        key: "defineAccessors",
        value: function value(model, reflection) {
          if (_get(_getPrototypeOf(SingularAssociation), "defineAccessors", this).apply(this, arguments), "function" == typeof reflection.constructable ? reflection.constructable() : void 0) return this.defineConstructors(model, reflection.name);
        }
      }, {
        key: "defineWriters",
        value: function value(mixin, name) {
          return mixin.prototype["assign".concat(s.capitalize(name))] = function (value) {
            return this.association(name).writer(value, !1, !0);
          }, mixin.prototype["update".concat(s.capitalize(name))] = function (value) {
            return this.association(name).writer(value, !0, !0);
          };
        }
      }, {
        key: "defineConstructors",
        value: function value(mixin, name) {
          return mixin.prototype["build".concat(s.capitalize(name))] = function (attributes) {
            return this.association(name).build(attributes);
          }, mixin.prototype["create".concat(s.capitalize(name))] = function (attributes, callback) {
            return this.association(name).create(attributes, callback);
          };
        }
      }]), SingularAssociation;
    }();
  }.call(void 0), function () {
    ActiveResource.prototype.Associations.prototype.Builder.prototype.BelongsTo = function () {
      var BelongsTo = function (_ActiveResource$proto13) {
        function BelongsTo() {
          return _classCallCheck(this, BelongsTo), _possibleConstructorReturn(this, _getPrototypeOf(BelongsTo).apply(this, arguments));
        }
        return _inherits(BelongsTo, ActiveResource.prototype.Associations.prototype.Builder.prototype.SingularAssociation), BelongsTo;
      }();
      return BelongsTo.macro = "belongsTo", BelongsTo;
    }.call(this);
  }.call(void 0), function () {
    ActiveResource.prototype.Associations.prototype.Builder.prototype.HasOne = function () {
      var HasOne = function (_ActiveResource$proto14) {
        function HasOne() {
          return _classCallCheck(this, HasOne), _possibleConstructorReturn(this, _getPrototypeOf(HasOne).apply(this, arguments));
        }
        return _inherits(HasOne, ActiveResource.prototype.Associations.prototype.Builder.prototype.SingularAssociation), HasOne;
      }();
      return HasOne.macro = "hasOne", HasOne;
    }.call(this);
  }.call(void 0), function () {
    ActiveResource.prototype.Immutable = function Immutable() {
      _classCallCheck(this, Immutable);
    };
  }.call(void 0), function () {
    ActiveResource.prototype.Immutable.prototype.Attributes = function () {
      function Attributes() {
        _classCallCheck(this, Attributes);
      }
      return _createClass(Attributes, null, [{
        key: "assignAttributes",
        value: function value(attributes) {
          var clone;
          return (clone = this.clone()).__assignAttributes(attributes), clone;
        }
      }, {
        key: "reload",
        value: function value() {
          var ref, resource, url;
          if (!(this.persisted() || (null != (ref = this.id) ? ref.toString().length : void 0) > 0)) throw "Cannot reload a resource that is not persisted or has an ID";
          return resource = this.clone(), url = this.links().self || ActiveResource.prototype.Links.__constructLink(this.links().related, this.id.toString()), this["interface"]().get(url, this.queryParams()).then(function (reloaded) {
            var fields;
            return fields = reloaded.attributes(), resource.klass().reflectOnAllAssociations().each(function (reflection) {
              var association, target;
              if ((association = reloaded.association(reflection.name)).loaded()) return target = association.reader(), ("function" == typeof reflection.collection ? reflection.collection() : void 0) && (target = target.toArray()), fields[reflection.name] = target;
            }), resource.__assignFields(fields), resource;
          });
        }
      }]), Attributes;
    }();
  }.call(void 0), function () {
    ActiveResource.prototype.Immutable.prototype.Errors = function (_ActiveResource$proto15) {
      function Errors() {
        return _classCallCheck(this, Errors), _possibleConstructorReturn(this, _getPrototypeOf(Errors).apply(this, arguments));
      }
      return _inherits(Errors, ActiveResource.prototype.Errors), _createClass(Errors, [{
        key: "add",
        value: function value(field, code) {
          var clone,
            detail = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : "";
          return (clone = this.base.clone()).errors().__add(field, code, detail), clone;
        }
      }, {
        key: "addAll",
        value: function value() {
          var clone;
          clone = this.base.clone();
          for (var _len7 = arguments.length, errors = new Array(_len7), _key7 = 0; _key7 < _len7; _key7++) errors[_key7] = arguments[_key7];
          return _.map(errors, function (error) {
            var _clone$errors;
            return (_clone$errors = clone.errors()).__add.apply(_clone$errors, _toConsumableArray(error));
          }), clone;
        }
      }, {
        key: "propagate",
        value: function value(errors) {
          var errorsByTarget,
            _this34 = this;
          return errorsByTarget = errors.inject({}, function (targetObject, error) {
            var association, field, nestedError, nestedField;
            if (field = (nestedField = error.field.split(".")).shift(), nestedError = _.clone(error), null == targetObject[field]) {
              try {
                association = _this34.base.association(field);
              } catch (error1) {
                association = null;
              }
              targetObject[field] = {
                association: association,
                errors: ActiveResource.Collection.build()
              };
            }
            return null != targetObject[field].association && (nestedError.field = 0 === nestedField.length ? "base" : nestedField.join(".")), targetObject[field].errors.push(nestedError), targetObject;
          }), _.each(errorsByTarget, function (errorsForTarget, k) {
            var association, baseErrors, clone, ref, relationshipResource;
            if (null == errorsForTarget.association) return errorsForTarget.errors.each(function (e) {
              return _this34.push(e);
            });
            if ((association = errorsForTarget.association).reflection.collection()) {
              if ((baseErrors = errorsForTarget.errors.select(function (e) {
                return "base" === e.field;
              })).each(function (e) {
                return e.field = k, errorsForTarget.errors["delete"](e);
              }), baseErrors.each(function (e) {
                return _this34.push(e);
              }), clone = null != (relationshipResource = association.target.first()) ? relationshipResource.__createClone({
                cloner: _this34.base
              }) : void 0) return _this34.base.__fields[association.reflection.name].replace(relationshipResource, clone), association.target.replace(relationshipResource, clone), clone.errors().clear(), clone.errors().propagate(errorsForTarget.errors);
            } else if (clone = null != (ref = association.target) ? ref.__createClone({
              cloner: _this34.base
            }) : void 0) return clone.errors().clear(), clone.errors().propagate(errorsForTarget.errors);
          });
        }
      }], [{
        key: "errors",
        value: function value() {
          return this.__errors || (this.__errors = new ActiveResource.prototype.Immutable.prototype.Errors(this));
        }
      }]), Errors;
    }();
  }.call(void 0), function () {
    ActiveResource.prototype.Immutable.prototype.Persistence = function () {
      function Persistence() {
        _classCallCheck(this, Persistence);
      }
      return _createClass(Persistence, null, [{
        key: "update",
        value: function value(attributes, callback) {
          var attributesKeys, oldAttributes;
          return attributesKeys = ActiveResource.prototype.Collection.build(_.keys(attributes)), oldAttributes = _.pick(this.attributes(), attributesKeys.toArray()), oldAttributes = _.defaults(oldAttributes, attributesKeys.inject({}, function (obj, k) {
            return obj[k] = null, obj;
          })), this.__createOrUpdate(this.assignAttributes(attributes)).then(null, function (resource) {
            return resource.__assignAttributes(oldAttributes), resource;
          }).then(callback, callback);
        }
      }, {
        key: "__createOrUpdate",
        value: function value() {
          var clone = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : this.clone();
          return clone.errors().reset(), clone.persisted() ? this.klass().resourceLibrary["interface"].patch(this.links().self, clone) : this.klass().resourceLibrary["interface"].post(this.links().related, clone);
        }
      }]), Persistence;
    }();
  }.call(void 0), function () {
    ActiveResource.prototype.Immutable.prototype.Base = function () {
      var Base = function (_ActiveResource$proto16) {
        function Base() {
          return _classCallCheck(this, Base), _possibleConstructorReturn(this, _getPrototypeOf(Base).call(this));
        }
        return _inherits(Base, ActiveResource.prototype.Base), Base;
      }();
      return ActiveResource.include(Base, ActiveResource.prototype.Immutable.prototype.Attributes, !0), ActiveResource.include(Base, ActiveResource.prototype.Immutable.prototype.Errors, !0), ActiveResource.include(Base, ActiveResource.prototype.Immutable.prototype.Persistence, !0), Base;
    }.call(this);
  }.call(void 0), activeResource;
});